import React, { useEffect, useState } from 'react';
import { Descriptions, Badge, Layout, Row, Col, Card, Button, Spin, Input } from 'antd';
import './documents.css';
import { SaleOrderService } from '@gtpl/shared-services/sale-management';
import { ConditionsRequest, CrrencySymbols, SaleOrderDetailDto, SaleOrderDetailViewInfoDTO } from '@gtpl/shared-models/sale-management';
import { FactoriesInput, PlantInvoiceDetailsModel, PlantInvoiceDetailsRequest, UnitsOfWeightInput, } from '@gtpl/shared-models/sale-management';
import { AlertMessages } from '@gtpl/shared-utils/alert-messages';
import { ExporterDataInput } from '@gtpl/shared-models/logistics';
import { GlobalStatus, UomEnum } from '@gtpl/shared-models/common-models';
import { useLocation } from 'react-router-dom';
import { ArrowLeftOutlined } from '@ant-design/icons'
import { PrinterOutlined } from '@ant-design/icons'
let converter = require('number-to-words');
import { numberToWords } from 'amount-to-words'
import ReactHTMLTableToExcel from 'react-html-table-to-excel';
import moment from 'moment';
import { ToWords } from 'to-words';
import stampImage from "./stamp.png";
import signature from "./signature.png"
import { GlobalPriceChartService } from 'libs/shared-services/masters/src/lib/global-price-chart.service';


// const { ToWords } = require('to-words');
const toWords = new ToWords({
  localeCode: 'en-US',
});
/* eslint-disable-next-line */
export interface ProformaInvoiceProps {
  saleOrderId: number;

}

export const getCssFromComponent = (fromDoc: Document, toDoc: Document) => {
  Array.from(fromDoc.styleSheets).forEach((styleSheet: CSSStyleSheet) => {
    try {
      if (styleSheet?.cssRules) { // true for inline styles and same-origin stylesheets
        const newStyleElement = toDoc.createElement("style");
        Array.from(styleSheet.cssRules).forEach((cssRule: CSSRule) => {
          newStyleElement.appendChild(toDoc.createTextNode(cssRule.cssText));
        });
        toDoc.head.appendChild(newStyleElement);
      }
    } catch (e) {
      console.warn("Could not access stylesheet rules for", styleSheet.href, e);
    }
  });
};
// export const getCssFromComponent = (fromDoc, toDoc) => {
//   Array.from(fromDoc.styleSheets).forEach((styleSheet: any) => {
//       if (styleSheet.cssRules) {
//           // true for inline styles
//           const newStyleElement = toDoc.createElement("style");
//           Array.from(styleSheet.cssRules).forEach((cssRule: any) => {
//               newStyleElement.appendChild(toDoc.createTextNode(cssRule.cssText));
//           });
//           toDoc.head.appendChild(newStyleElement);
//       }
//   });
// };
export function ProformaInvoice(props: ProformaInvoiceProps) {
  let location = useLocation();
  const salOrderService = new SaleOrderService();
  const [plantDetails, setPlantDetails] = useState<PlantInvoiceDetailsModel>();
  const soId = location.state;
  const [remarksData, setRemarksData] = useState<string>(undefined);
  const { TextArea } = Input;
  const defaultDeclaration = 'We declare that this invoice shows the actual price of the goods described and that all particulars are true and correct'
  const [conditionRes, setConditionRes] = useState([]);

  console.log(location.state);
  let totalCases = 0;
  // let netWeightInKgs = 0;
  let totalAmount = 0;
  let itemsTotalAmount = 0;
  let totalLbWeight = 0;
  let totalGrossWeight = 0;
  let totalFrozenWeight = 0;
  let totalInvoiceAmount = 0;

  let FOBInRs = 0;
  let FOBInUSD = 0;
  let lbPouchWeight;
  let kgPouchWeight;

  let netWeightCalc;
  let totalAm = 0;
  
  let netWeightInKgs = 0;
  let netWeightInLbs = 0;
  let grossWeightInKg;
  let frozenWeightInKg;
   let cgst = 0;
  let sgst = 0;
  let igst = 0;
  let cgstPer = 0;
  let sgstPer = 0;
  let igstPer = 0;
 
  let declarationNote

  let totalAmnt = 0;
  let newUnitPrice ;
  let newTotalAmount = 0;
  let antiDumping;
  let fob;
  const [ mainData, setMainData ] = useState<any[]>([])
  const globalPriceService = new GlobalPriceChartService()


  useEffect(()=>{
    getAntiDumpingPrice()
  },[])


  const getAntiDumpingPrice = () =>{
    globalPriceService.getAntiDumpingPrice().then(res=>{
      if(res.status){
        setMainData(res.data)
   }else{
        setMainData([])
    }
    }).catch(err=>{
        setMainData([]) 
    })
  }
  const printOrder = () => {
    const divContents = document.getElementById('printme').innerHTML;
    const element = window.open('', '', 'height=700, width=1020');

    // Write content to the new window
    element.document.write(`
        <html>
        <body>
            ${divContents}
            <style>
                #table-to-xls {
                    line-height: 1.2;
                    font-weight:500;
                }
                #table-to-xls h2 {
                    margin-bottom: 0px;
                }
                #table-to-xls tr td {
                    font-size: 10px;
                    font-weight:500;
                }
            </style>
        </body>
        </html>
    `);

    getCssFromComponent(document, element.document);
    element.document.close();

    setTimeout(() => {
      element.print();
      element.close(); // to close window when click on cancel/Save
   }, 1000);
  };

  const getData = (saleOrderId) => {
    // const reqObj = new PlantInvoiceDetailsRequest(1);
    salOrderService.getPlantInvoiceDetails(new PlantInvoiceDetailsRequest(saleOrderId)).then((res) => {
      console.log(res);
      if (res.status) {
        console.log(res.data.proformaInvoiceDate,'ooooooooooooo');
        setPlantDetails(res.data);
        const request = new ConditionsRequest();
        request.country = res.data.country;
        request.frozenWeight = res.data.frozenWeight;
        request.grossWeight = res.data.grossWeight;
        request.notifyParty = res.data.notifyPartyOne;
        request.deliveryTerms = res.data.deliveryTerms;
        request.buyer = res.data.endCustomerName;
        // request.netWeight=
        salOrderService.getConditionsBasedLogistics(request).then((res) => {
          if (res.status) {
            setConditionRes(res.data);
          }
        });
        
      } else {
        if (res.intlCode) {
          setPlantDetails(undefined);
          AlertMessages.getErrorMessage(res.internalMessage);
        } else {
          AlertMessages.getErrorMessage(res.internalMessage);
        }
      }
    })
      .catch((err) => {
        AlertMessages.getErrorMessage(err.message);
        setPlantDetails(undefined);
      });
  };

//   useEffect(() => {
//     // setRemarksData("text");
//     if (props.saleOrderId) {
//       getData(props.saleOrderId);
//     }
//     // window.print()
//   }, [props.saleOrderId])


useEffect(() => {
  if (props.saleOrderId) {
    getData(props.saleOrderId);
  }
}, [props.saleOrderId])
let exporterDetails = ExporterDataInput;

const exporterIdOrUnitCodeId = plantDetails?.isInvoiced === GlobalStatus.YES 
  ? plantDetails?.exporterId 
  : plantDetails?.unitData?.unitcodeId;

const exporterData = exporterDetails.find(
  (item) => item.value === exporterIdOrUnitCodeId
);
const processingId= plantDetails?.processingUnit;

const processingData = exporterDetails.find(
  (item) => item.value === processingId
);
  let exporterPlant = FactoriesInput;
  const exportersPlant = exporterPlant.find(
    (item) => item.id == plantDetails?.invoicedPlant?.unitcodeId
  )
  let unitInput = FactoriesInput;
  const unitsData = FactoriesInput.find(item => item.id == plantDetails?.unitId)
  const tableData = () => {
    const tableDataArray = [];
    for (const data of plantDetails?.saleOrderItems) {
      const tableDataArray = data;
    }
  };
  
  
let spanVal = 0
let adjustSpan = 0
  const rowSpanValue =Math.round(plantDetails?.gradeInfo?.length  / 2);
  if(plantDetails?.gradeInfo?.length % 2 !== 0 && plantDetails?.gradeInfo?.length > 1){
    console.log('odd and > 1',Math.round(plantDetails?.gradeInfo?.length/2));
    
    spanVal = Math.round(plantDetails?.gradeInfo?.length/2)
    adjustSpan = Math.round(plantDetails?.gradeInfo?.length/2) -1
  }
  else if(plantDetails?.gradeInfo?.length === 1){
    spanVal =1
    console.log('equals to 1',Math.round(plantDetails?.gradeInfo?.length));

    adjustSpan =1
  }else{
    spanVal = Math.round(plantDetails?.gradeInfo?.length/2)
    adjustSpan = Math.round(plantDetails?.gradeInfo?.length/2) 
    console.log('even',Math.round(plantDetails?.gradeInfo?.length/2));

  }
  // return 'test';
  // const print = () => {
  //   var content = document.getElementById("divcontents");
  //   var pri = document.getElementById("ifmcontentstoprint").contentWindow;
  //   pri.document.open();
  //   pri.document.write(content.innerHTML);
  //   pri.document.close();
  //   pri.focus();
  //   pri.print();
  // }
  const handleRemarks = (value) => {
    setRemarksData(value);
  }
  let hasNumber = /\d/;
  let normalOrder = hasNumber.test(plantDetails?.buyerPoNo);
  let lotRefString = '';
  let lotNo = '';
  let RefNo = '';
  if (normalOrder) {
    if (plantDetails?.lotCode) {
      lotNo = 'LOT NO. ' + plantDetails?.lotCode + ', '
    }
    if (plantDetails?.buyerPoNo) {
      RefNo = 'REF NO. ' + plantDetails?.buyerPoNo
    }
    lotRefString = lotNo + RefNo
  }


  let totalContainersRowSpan = 0;
  let containerProductLevelRowSpan = new Map<number, number>(); // map of array_index_of_product => no of rows in it
  plantDetails?.gradeInfo?.forEach((g, prodIndex) => {
    let prodRowCount = 0;
    g?.info?.forEach((r, i) => {
      // incre,ent the total row span for every record
      totalContainersRowSpan++;
      prodRowCount++;
    });
    containerProductLevelRowSpan.set(prodIndex, prodRowCount);
  });
  const copiedContainerRowSpan = totalContainersRowSpan;

  const sealNoRowPortionSpan = (totalContainersRowSpan/2);
  console.log(totalContainersRowSpan);
  console.log(containerProductLevelRowSpan);

  const lhsContent = [];
  const rhsContent = [];

  function ConstrunctLhsContent(plantDetails: PlantInvoiceDetailsModel) {
    lhsContent.push(
      <>
        <u><b>Exporter:</b></u><br />
          <div>{exporterData?.company ? exporterData?.company : ''}</div>
          <div>{exporterData?.addressOne ? exporterData?.addressOne + ',' : ''}</div>
          <div>{exporterData?.addressTwo
            ? exporterData?.addressTwo + ' - ' + exporterData?.postalCode
            : ''}</div>
          <div>{exporterData?.state + ', ' + exporterData?.country}</div>
          <div>PHONE:{exporterData?.phoneNumber}</div>
          {exporterData?.faxNo!=null? <div>FAX:{exporterData?.faxNo}</div>:''}

          
          <div>GSTIN: {exporterData?.GSTNumber}</div>
          <div> {plantDetails?.country==="USA"? (
                    <>
                      <b style={{ textAlign: 'center' }}>USFDA REGN NO:</b>
                      {exporterData?.usfdaRegNo}
                    </>
                  ) : (
                    <></>
                  )}</div>
      </>
    );

    {
      plantDetails?.consigneeAddress != undefined ||
      plantDetails?.consignee != null ? (
        lhsContent.push(
          <>
            <b>
              <u>Consignee:</u>
            </b>
            <br />
            {plantDetails?.consignee}
            {plantDetails?.consignee ? ':' : ''}
            <br />
            {plantDetails?.consigneeAddress?.split(',').join(',')}
            <br />
            {plantDetails?.country ? plantDetails?.country : ''}
          </>
        )
      ) : (
        <></>
      );
    }

    if (conditionRes?.[0]?.importerDetails === true) {
      if (plantDetails?.endCustomerName === "BEAVER STREET FISHERIES, INC") {
        lhsContent.push(
          <>
           
                {/* Importer of Record */}
                <td style={{ width: "70%", borderRight: "1px solid black", padding: "10px", verticalAlign: "top" }}>
                  <u><b>IMPORTER OF RECORD:</b></u>
                  <br />
                  {exporterData?.company ? exporterData?.company : ''}
                  <br />
                  {exporterData?.addressOne ? exporterData?.addressOne + ',' : ''}
                  <br />
                  {exporterData?.addressTwo
                    ? exporterData?.addressTwo + ' - ' + exporterData?.postalCode
                    : ''}
                  <br />
                  {exporterData?.state + ', ' + exporterData?.country}
                  <br />
                  PHONE: {exporterData?.phoneNumber}
                  <br />
                  {exporterData?.faxNo ? <>FAX: {exporterData?.faxNo} <br /></> : <></>}
                  
                  <b>IMPORT ON RECORD: </b>
                  {plantDetails?.country === 'USA' ? exporterData?.importerOfRecord : ''}
                </td>
    
                {/* Shipping Terms */}
                <td style={{ width: "30%", borderLeft: "1px solid black", padding: "10px", verticalAlign: "top" }}>
                  <u><b>SHIPPING TERMS:</b></u>
                  <br />
                  {plantDetails?.shipmentTerms}
                </td>
             
          </>
        );
      } else {
        // Only Importer of Record should appear
        lhsContent.push(
          <>
                  <u><b>IMPORTER OF RECORD:</b></u>
                  <br />
                  {exporterData?.company ? exporterData?.company : ''}
                  <br />
                  {exporterData?.addressOne ? exporterData?.addressOne + ',' : ''}
                  <br />
                  {exporterData?.addressTwo
                    ? exporterData?.addressTwo + ' - ' + exporterData?.postalCode
                    : ''}
                  <br />
                  {exporterData?.state + ', ' + exporterData?.country}
                  <br />
                  PHONE: {exporterData?.phoneNumber}
                  <br />
                  {exporterData?.faxNo ? <>FAX: {exporterData?.faxNo}</> : ''}
                  <br />
                  <b>IMPORT ON RECORD: </b>
                  {plantDetails?.country === 'USA' ? exporterData?.importerOfRecord : ''}
          </>
        );
      }
    }
    
    

    rhsContent.push(
      <>
        <b>Invoice No: </b>
        {plantDetails?.proformaInv}
      </>
    );

    rhsContent.push(
      <>
        <b>Invoice Date: </b>
        {plantDetails?.proformaInvoiceDate
          ?plantDetails?.proformaInvoiceDate
          : ''}
      </>
    );

    rhsContent.push(
      <>
        <b>Place Of Supply: </b>{' '}
        {/* {(plantDetails?.saleOrderItems[0]?.destinationDetails
          ? (plantDetails?.shipmentTerms ? plantDetails?.shipmentTerms : '') +
            ',' +
            plantDetails?.saleOrderItems[0]?.destinationDetails?.toUpperCase()
          : '') +
          ',' +
          (plantDetails?.country ? plantDetails?.country : '')} */}
        {(plantDetails?.saleOrderItems[0]?.destinationDetails?plantDetails?.saleOrderItems[0]?.destinationDetails?.toUpperCase():"")+','+(plantDetails?.country ? plantDetails?.country : '')}
      </>
    );

    rhsContent.push(
      <>
        <b>Tax is payable On Reverse Charge : NO</b>
      </>
    );

    // rhsContent.push(
    //   <>
    //     <b>GST NO: </b>
    //     {exporterData?.GSTNumber}
    //   </>
    // );

    rhsContent.push(
      <>
        <b>
          Exporter's Ref
          <br />
          IE Code{' '}
        </b>{' '}
        {exporterData?.ieCode}
      </>
    );

    {
      conditionRes?.[0]?.duplicateBuyer === false ? (
        rhsContent.push(
          <>
            {plantDetails?.consigneeAddress != undefined ||
            plantDetails?.consignee != null ? (
              <u><b> Buyer </b></u>
            ) : (
              <b>Buyer & Consignee:</b>
            )}
           <br />
        {plantDetails?.endCustomerName}
        {plantDetails?.endCustomerName ? ':' : ''}
        <br />
        {plantDetails?.saleOrderItems[0]?.buyerAddress?.split(',')}
        <br />
        {plantDetails?.country ? plantDetails?.country:''}
      </>
        )
      ) : (
        <></>
      );
    }

    // rhsContent.push(
    //   <>
    //     {plantDetails?.consigneeAddress != undefined ||
    //     plantDetails?.consignee != null ? (
    //       <b> Buyer </b>
    //     ) : (
    //       <b>Buyer & Consignee:</b>
    //     )}
    //     <br />
    //     {plantDetails?.endCustomerName}
    //     {plantDetails?.endCustomerName ? ':' : ''}
    //     <br />
    //     {plantDetails?.saleOrderItems[0]?.buyerAddress?.split(',')}
    //     <br />
    //     {plantDetails?.country ? plantDetails?.country:''}
    //     <br/>
    //     {/* {plantDetails?.saleOrderItems[0]?.buy} */}
    //   </>
    // );

    {
      conditionRes?.[0]?.notifyPartyParam === true ? (
        rhsContent.push(
          <>
            <u><b>Notify Party:</b></u><br/>
            {plantDetails.notifyPartyOne != null ? (
              <>
                {/* <u>Notify party 1</u> */}
                
                <b>{plantDetails?.notifyPartyOne?.split('\n')[0]}</b>
                <br />
                {plantDetails?.notifyPartyOne?.split('\n')[1]}
                <br />
                {plantDetails?.notifyPartyOne?.split('\n')[2]}
                <br />
                {plantDetails?.notifyPartyOne?.split('\n')[3]}
              </>
            ) : (
              ''
            )}
            {plantDetails.notifyPartyTwo != null ? (
              <>
                {/* <u>Notify party 2</u> */}
                
                <b>{plantDetails?.notifyPartyTwo?.split('\n')[0]}</b>
                <br />
                {plantDetails?.notifyPartyTwo?.split('\n')[1]}
                <br />
                {plantDetails?.notifyPartyTwo?.split('\n')[2]}
                <br />
                {plantDetails?.notifyPartyTwo?.split('\n')[3]}
              </>
            ) : (
              ''
            )}
            {plantDetails.notifyPartyThree != null ? (
              <>
                {/* <u>Notify party 3</u> */}
                
                  <b>{plantDetails?.notifyPartyThree?.split('\n')[0]}</b>
                  <br />
                  {plantDetails?.notifyPartyThree?.split('\n')[1]}
                  <br />
                  {plantDetails?.notifyPartyThree?.split('\n')[2]}
                  <br />
                  {plantDetails?.notifyPartyThree?.split('\n')[3]}
              </>
            ) : (
              ''
            )}
            {plantDetails.notifyPartyFour != null ? (
              <>
                {/* <u>Notify party 4</u> */}
                
                <b>{plantDetails?.notifyPartyFour?.split('\n')[0]}</b>
                <br />
                {plantDetails?.notifyPartyFour?.split('\n')[1]}
                <br />
                {plantDetails?.notifyPartyFour?.split('\n')[2]}
                <br />
                {plantDetails?.notifyPartyFour?.split('\n')[3]}
              </>
            ) : (
              ''
            )}
          </>
        )
      ) : (
        <></>
      );
    }

    {
      plantDetails?.htsInfo?.[0]?.htsCode != null ||
      plantDetails?.htsInfo?.[0]?.htsCode != undefined ? (
        rhsContent.push(
          <>
            <b>HTS Code : </b>
            {plantDetails?.htsInfo.map((e) => e.htsCode).join(',')}
          </>
        )
      ) : (
        <></>
      );
    }

    rhsContent.push(
      <>
        <b>{conditionRes?.[0]?.terms} : </b>{' '}
        {conditionRes?.[0]?.terms=='DELIVERY TERMS'?plantDetails?.deliveryTerms:plantDetails?.shipmentTerms}
      </>
    );  
    {
      plantDetails?.saleOrderItems[0]?.buyerAddress.replace(/,/g, '') !=
      plantDetails?.saleOrderItems[0]?.deliveryaddress.replace(/,/g, '') ? (
        rhsContent.push(
          <>
            <b>
              <u>Shipp to:</u>
            </b>
            {plantDetails?.saleOrderItems[0]?.deliveryaddress}
          </>
        )
      ) : (
        <></>
      );
    }
  }
  console.log(ConstrunctLhsContent(plantDetails));

  const uniqueSizes = new Set();
  console.log(uniqueSizes,"uniqueSizes")

plantDetails?.gradeInfo.forEach(g => {
  g.info.forEach(r => {
    uniqueSizes.add(`${r.minGrade}/${r.maxGrade}`);
  });
});
const sizeString = Array.from(uniqueSizes).join(', ');
console.log(sizeString,"sizeString")

  let lhsCount = lhsContent.length;
  let rhsCount = rhsContent.length;
  const lhsRowSpanMap = new Map<number, number>();
  const lhsRowSpanCopyMap = new Map<number, number>();
  const blockSpanSize = Math.round(rhsCount / lhsCount);
  const blockSpanSizeRem = Math.round(rhsCount % lhsCount);
  let rowNumber = 1;
  let index=0; //1
  let fulfilledCount = 0;
  while (lhsCount > 0) {
    if(index === 0) {
    lhsRowSpanMap.set(rowNumber, blockSpanSize);//1,5 
    lhsRowSpanCopyMap.set(rowNumber, blockSpanSize);//1 ,5 
    fulfilledCount = blockSpanSize;//5
  } else {
    const remaing = rhsCount - fulfilledCount;//9-5=4
    const breakDownVal = Math.round( remaing / lhsCount);//4/3=1
    lhsRowSpanMap.set(rowNumber, breakDownVal);//1,5 | 2,1
    lhsRowSpanCopyMap.set(rowNumber, breakDownVal);//1 ,5 | 2,1
    fulfilledCount =blockSpanSize+ breakDownVal;
    
  }
    index++;//1
    rowNumber++;//2
    lhsCount--;//1
  }

  let lhsPrintingRowNumber = 1;
  let lhsPrintingIndexNumber = 0;
  let totalNetAmount=0
const hasBundelCategory = plantDetails?.gradeInfo?.some(e => 
  e.info.some(val => val?.bundelCategory === true)
);
  return (
    <Card
    // title="Proforma Invoice"
    // style={{ textAlign: "center" }}
    // headStyle={{ backgroundColor: "#69c0ff", border: 0 }}
    extra={
        <span style={{ color: "white" }}>
                      <Button onClick={printOrder} className='noprint' style={{float:'right', backgroundColor:'#69c0ff'}}><span style={{ color: 'white' }}><PrinterOutlined /> Print</span></Button>
                      </span>
    }
>
    <div >
      {/* <span style={{ alignContent: 'left', backgroundColor: 'red' }}>
         <ReactHTMLTableToExcel
          id="test-table-xls-button"
          className="download-table-xls-button"
          table="table-to-xls"
          filename="PInvoice"
          sheet="CommercialInvoice"
          buttonText="Get Excel" /> 
      </span>
      <br /> */}
      {plantDetails ?
        <html>

          <head></head>
          <br />
          <body id='printme' className={"stylesInfo"}>


            <br></br>
            <table className={'ta-b'} style={{ width: '100%' }} id="table-to-xls" >
              <tr><td className={'ta-b'} colSpan={9} style={{ textAlign: 'center',}}>
                <h2> PROFORMA INVOICE</h2></td></tr>
              {rhsContent.map((r, i) => {
                let currRowSpanConsumption = lhsRowSpanMap.get(
                  lhsPrintingRowNumber
                ); // 3
                let currRowSpanReducedCons = lhsRowSpanCopyMap.get(
                  lhsPrintingRowNumber
                ); // 3/2
                lhsRowSpanCopyMap.set(
                  lhsPrintingRowNumber,
                  currRowSpanReducedCons - 1
                ); // 2/1

                if (Number(currRowSpanReducedCons) - 1 === 0) {
                  lhsPrintingIndexNumber++;
                  lhsPrintingRowNumber++;
                }

                return (
                  <>
                    <tr>
                      <td
                        colSpan={5}
                        className={'ta-b'}
                        rowSpan={currRowSpanConsumption}
                        style={{
                          display:
                            currRowSpanConsumption === currRowSpanReducedCons
                              ? ''
                              : 'none',
                              verticalAlign:'top',
                        }}
                      >
                        {lhsContent[lhsPrintingIndexNumber]}
                      </td>
                      <td className={'ta-b'} colSpan={5} >
                        {r}
                      </td>
                    </tr>
                  </>
                );
              })}
              {/* <tr>
                <td className={'ta-b'} colSpan={4} rowSpan={5}>
                  <b>Exporter:</b> <br />
                  <h4 style={{ display: 'inline',lineHeight:'1px' }}>{(exporterData?.name) ? exporterData?.name : ''}</h4><br />
                  {(exporterData?.addressOne) ? exporterData?.addressOne + ',' : ''}
                  <br />
                  {(exporterData?.addressTwo) ? (exporterData?.addressTwo) + ' - ' + exporterData?.postalCode : ''}
                  <br />
                  {exporterData?.state + ', ' + exporterData?.country}

                  <br />
                  <h4 style={{ display: 'inline' }}>GSTIN: </h4>{exporterData?.GSTNumber}
                  <br />
                  <h4 style={{ display: 'inline' }}>USFDA REGN NO: </h4>{exporterData?.usfdaRegNo}
                </td>
                <td className={'ta-b'} colSpan={5}>
                  <b>Invoice No: </b>
                  {plantDetails?.proformaInv}<br />
                 
                </td>

            
              </tr>
              <tr>
              <td className={'ta-b'} colSpan={5}>
                 
                  <b>Invoice Date: </b>
                  {plantDetails?.createdAt?moment(plantDetails?.createdAt).format('DD-MM-YYYY'):''}
                </td>
              </tr>
              <tr>
              <td className={'ta-b'} colSpan={5}>
                  <b>Place Of Supply: </b>
                  <br/>
                  <b>Tax is payable On Reverse Charge:</b>NO
                </td>
              </tr>
              <tr>
              <td className={'ta-b'} colSpan={5}>
                  <b>Exporter's Ref<br />
                    IE Code </b> {exporterData?.ieCode}
                </td> 
              </tr>
              <tr>
              <td className={'ta-b'} colSpan={5}>
              <b> Buyer & Consignee:</b><br />
                  {plantDetails?.endCustomerName}{plantDetails?.endCustomerName ? ':' : ''}<br />
                  {plantDetails?.saleOrderItems[0]?.customeraddress?.split(",")}<br />
                  {plantDetails?.country ? plantDetails?.country:''}
                </td>
              </tr>
              <tr>
              <td className={'ta-b'} colSpan={4} rowSpan={2}>
                  <b>
                    Importer of record:
                  </b><br />
                  <h4 >{(exporterData?.name) ? exporterData?.name : ''}<br />
                  {(exporterData?.addressOne) ? exporterData?.addressOne + ',' : ''}
                  <br />
                  {(exporterData?.addressTwo) ? (exporterData?.addressTwo) + ' - ' + exporterData?.postalCode : ''}
                  <br />
                  {exporterData?.state + ', ' + exporterData?.country}
                <br/>
                <b>Import On Record: </b>{plantDetails?.country==='USA'?exporterData?.importerOfRecord:''}
                </h4>                </td>
                <td className={'ta-b'} colSpan={5}>
                <b>Notify Party:</b>

                
                     {
                  (plantDetails.notifyPartyOne!= null) ?
                    
                      <><br />
                        <b>{plantDetails?.notifyPartyOne?.split("\n")[0]}</b><br />
                        {plantDetails?.notifyPartyOne?.split("\n")[1]}<br />
                        {plantDetails?.notifyPartyOne?.split("\n")[2]}<br />
                        {plantDetails?.notifyPartyOne?.split("\n")[3]}<br /></>:''
                }
                {
                  (plantDetails.notifyPartyTwo!= null) ?

                  <><br />
                        <b>{plantDetails?.notifyPartyTwo?.split("\n")[0]}</b><br />
                        {plantDetails?.notifyPartyTwo?.split("\n")[1]}<br />
                        {plantDetails?.notifyPartyTwo?.split("\n")[2]}<br />
                        {plantDetails?.notifyPartyTwo?.split("\n")[3]}<br /><br /></>:''

                      }


{
                  (plantDetails.notifyPartyThree!= null) ?
                    
                      <><br />
                        <b>{plantDetails?.notifyPartyThree?.split("\n")[0]}</b><br />
                        {plantDetails?.notifyPartyThree?.split("\n")[1]}<br />
                        {plantDetails?.notifyPartyThree?.split("\n")[2]}<br />
                        {plantDetails?.notifyPartyThree?.split("\n")[3]}<br /><br /></>:''


                      }
                {
                  (plantDetails.notifyPartyFour!= null) ?

                  <><br />
                        <b>{plantDetails?.notifyPartyFour?.split("\n")[0]}</b><br />
                        {plantDetails?.notifyPartyFour?.split("\n")[1]}<br />
                        {plantDetails?.notifyPartyFour?.split("\n")[2]}<br />
                        {plantDetails?.notifyPartyFour?.split("\n")[3]}<br /><br /></>:''
                }
            </td>
              </tr>
                <tr>
                <td className={'ta-b'} colSpan={5}>
                    <b>Delivery Terms:</b>
                    {plantDetails?.deliveryTerms}
                </td>
                </tr> */}




                {/* <tr>
                <td className={'ta-b'} colSpan={3}>
                    <b>Container No:</b>
                    {plantDetails?.saleOrderItems[0]?.containerNo}
                </td>
                <td className={'ta-b'} colSpan={2}>
                    <b>Seal No:</b>
                    {plantDetails?.saleOrderItems[0]?.linearSelaNo}
                </td>
                </tr> */}
                   <tr>
                <td
                  className={'ta-b'}
                  colSpan={9}
                  style={{
                    textAlign: 'center',
                  }}
                >
                  <b>{conditionRes?.[0]?.poLabel} : </b>{' '}
                  {plantDetails.custPoNo}{' '}
                  <b>Date : </b>{' '}
                  {moment(plantDetails.poDate).format('DD-MM-YYYY')}
                  {' '}
                  <b>Shipment Date : </b>{moment(plantDetails.actualEdl)?.format('DD-MM-YYYY')}{' '}
                  </td>
              </tr>
              
              <tr>
                <td className={'ta-b'} style={{textAlign:"center"}}>
                  <b>Pre Carriage By</b>
                </td>
                <td className={'ta-b'} style={{textAlign:"center"}}>
                  <b>Vessel No</b>
                </td>
                <td className={'ta-b'} style={{textAlign:"center"}}>
                  <b>Port Of Loading</b>
                </td>
                <td className={'ta-b'} style={{textAlign:"center"}}>
                  <b>Port Of Discharge</b>
                </td>
                <td className={'ta-b'} style={{textAlign:"center"}} colSpan={2}>
                  <b>
                    {conditionRes?.[0]?.destinationDetails
                      ? conditionRes?.[0]?.destinationDetails
                      : ''}
                  </b>
                </td>
                <td className={'ta-b'} style={{textAlign:"center"}} colSpan={2}>
                  <b>Terms & Payments</b>
                </td>
                <td className={'ta-b'} style={{textAlign:"center"}}>
                  <b>Origin Of Goods</b>
                </td>
              </tr>
              <tr>
                <td className={'ta-b'} style={{textAlign:"center"}}>&nbsp;</td>
                <td className={'ta-b'} style={{textAlign:"center"}}> &nbsp;</td>
                <td className={'ta-b'} style={{textAlign:"center"}}>
                  <b>
                   Any Port/India
                  </b>
                </td>
                <td className={'ta-b'} style={{textAlign:"center"}}>
                  {(plantDetails?.saleOrderItems[0]?.destinationDetails
                    ? plantDetails?.saleOrderItems[0]?.destinationDetails?.toUpperCase()
                    : '') +
                    ',' +
                    (plantDetails?.country ? plantDetails?.country : '')}
                </td>
                <td className={'ta-b'} style={{textAlign:"center"}} colSpan={2}>
                  {(plantDetails?.saleOrderItems[0]?.destinationDetails
                    ? plantDetails?.saleOrderItems[0]?.destinationDetails?.toUpperCase()
                    : '') +
                    ',' +
                    (plantDetails?.country ? plantDetails?.country : '')}
                </td>
                <td className={'ta-b'} style={{textAlign:"center"}} colSpan={2}>
                  {plantDetails?.saleOrderItems[0]?.paymentTerms}
                </td>
                <td className={'ta-b'} style={{textAlign:"center"}} colSpan={1}>
                  INDIA
                </td>
              </tr>
                <tr>
                    <td className={'ta-b'}><b>Marks & Nos.</b></td>
                    <td className={'ta-b'} colSpan={plantDetails?.isItem === true?2:3} style={{textAlign:'center'}}><b>Description Of Goods</b></td>
                    {plantDetails?.isItem === true? (<><td className={'ta-b'} colSpan={1}><b>Item Code</b></td></>):(<></>)}
                    <td className={'ta-b'}><b>Size</b></td>
                    {hasBundelCategory?
                (<td className={'ta-b'} style={{textAlign:"center"}}>
                  <b>No.Of Bundels</b>
                </td>):
                  (<td className={'ta-b'} style={{textAlign:"center"}}>
                  <b>No.Of Cartons</b>
                </td>)}
                 <td className={'ta-b'} style={{ textAlign: 'center', borderBottom: '0px' }} >
                  <b>Quantity 
                     {/* IN KGs */}
                     {conditionRes?.[0]?.quantityUom === true
                      ? '(IN LBS)'
                      : '(IN KGS)'} 
                     </b>
                </td>
                <td className={'ta-b'}><b>Price USD/{conditionRes?.[0]?.quantityUom === true
                      ? 'LB'
                      : 'KG'} </b></td>
                   <td className={'ta-b'}><b>Amount IN USD 
                    {/* {
                    plantDetails?.country === 'CANADA' || plantDetails?.country === 'USA' || plantDetails?.country === 'UAE' ? <>
                    </> : <>{plantDetails?.shipmentTerms}</>
                  } <br />  */}
                  
               </b></td>
                </tr>

                
  {
    // let totalRowSpan = 0;
    plantDetails.gradeInfo.map((g, prodIndex) => {
      let prodRowSpan = containerProductLevelRowSpan.get(prodIndex);
      return g.info.map((r, index) => {
      
        let freightCharges =
          plantDetails?.freightCharges === undefined
            ? 0
            : plantDetails?.freightCharges;
        let exchangeRate =
          plantDetails?.exchangeRate === undefined
            ? 0
            : plantDetails?.exchangeRate;
        totalCases += r.noOfCases;
        const uom = UnitsOfWeightInput.find(
          (uom) => uom.value == r.uomId
        );
        const uomPrice = UnitsOfWeightInput.find(
          (uom) => uom.value == r.priceUom
        );
        let finalNetWeight;
        let unitPrice;
        let invUnitPrice;
        if (plantDetails.isInvoiced == GlobalStatus.YES) {
          // if (uom.name == UomEnum.LB || uom.name == UomEnum.OZ) {
          //   {
          //     conditionRes?.[0]?.quantityUom === true
          //       ? (finalNetWeight = Number(r.quatity))
          //       : (finalNetWeight = (
          //           Number(r.quatity) * 0.454
          //         ).toFixed(3));
          //   } // converting to kg
          //   unitPrice = (Number(r.revisedPrice) / 0.454).toFixed(2);
          //   grossWeightInKg = (
          //     Number(
          //       plantDetails?.grossWeight
          //         ? plantDetails?.grossWeight
          //         : 0
          //     ) * 0.454
          //   ).toFixed(3);
          //   frozenWeightInKg = (
          //     Number(
          //       plantDetails?.frozenWeight
          //         ? plantDetails?.frozenWeight
          //         : 0
          //     ) * 0.454
          //   ).toFixed(3);
          //   netWeightInKgs += Number(r.quatity)*0.454
          //   netWeightInLbs += Number(r.quatity)

          // } else {
          //   {
          //     conditionRes?.[0]?.quantityUom === true
          //       ? (finalNetWeight = (
          //           Number(r.quatity) / 0.454
          //         ).toFixed(3))
          //       : (finalNetWeight = Number(r.quatity).toFixed(3));
          //   }
          //   unitPrice = Number(r.price).toFixed(2);
          //   grossWeightInKg = Number(
          //     plantDetails?.grossWeight
          //       ? plantDetails?.grossWeight
          //       : 0
          //   ).toFixed(3);
          //   frozenWeightInKg = Number(
          //     plantDetails?.frozenWeight
          //       ? plantDetails?.frozenWeight
          //       : 0
          //   ).toFixed(3);
          //   netWeightInKgs += Number(r.quatity)
          //   netWeightInLbs += Number(r.quatity)/0.454
         
          // }
          if (conditionRes?.[0]?.quantityUom === true) {
            // converting quantity to LB------
            if (uom.name == UomEnum.LB || uom.name == UomEnum.OZ) {
              finalNetWeight = Number(r.quatity)
            }else{
              finalNetWeight = Number(r.quatity)/ 0.454
            }
            // converting price to LB------
            if (
              uomPrice.name == UomEnum.LB ||
              uomPrice.name == UomEnum.OZ
            ) {
              unitPrice = Number(r.price).toFixed(5);
            } else {
              unitPrice = (Number(r.price) * 0.454).toFixed(5);
            }
          } else {
            // converting price to KG------
             if (uomPrice.name == UomEnum.LB || uomPrice.name == UomEnum.OZ) {
            unitPrice = (Number(r.price) / 0.454).toFixed(5);
            }else{
              unitPrice = (Number(r.price)).toFixed(5);
            }
            // converting quantity to KG------
            if (uom.name == UomEnum.LB || uom.name == UomEnum.OZ) {
              finalNetWeight = Number(r.quatity) * 0.454
            }else{
              finalNetWeight = Number(r.quatity)
            }
          }

          if (uom.name == UomEnum.LB || uom.name == UomEnum.OZ) {
            // grossweight converting to KG----------
            grossWeightInKg = (
              Number(
                plantDetails?.grossWeight
                  ? plantDetails?.grossWeight
                  : 0
              ) * 0.454
            ).toFixed(3);
            // frozenweight converting to KG----------

            frozenWeightInKg = (
              Number(
                plantDetails?.frozenWeight
                  ? plantDetails?.frozenWeight
                  : 0
              ) * 0.454
            ).toFixed(3);
            netWeightInKgs += Number(r.quatity) /0.454;
            netWeightInLbs += Number(r.quatity);
          } else {
            // grossweight converting to LB----------
            grossWeightInKg = Number(
              plantDetails?.grossWeight
                ? plantDetails?.grossWeight
                : 0
            ).toFixed(3);
            // frozenweight converting to LB----------

            frozenWeightInKg = Number(
              plantDetails?.frozenWeight
                ? plantDetails?.frozenWeight
                : 0
            ).toFixed(3);
            netWeightInKgs += Number(r.quatity);
            netWeightInLbs += Number(r.quatity) / 0.454;
          }


        } else {
        //   if (uom.name == UomEnum.LB || uom.name == UomEnum.OZ) {
        //     {
        //       conditionRes?.[0]?.quantityUom === true
        //         ? (finalNetWeight = Number(r.quatity))
        //         : (finalNetWeight = (
        //             Number(r.quatity) * 0.454
        //           ).toFixed(3));
        //     }
        //     unitPrice = (Number(r.revisedPrice) * 0.454).toFixed(2);
        //     grossWeightInKg = (
        //       Number(
        //         plantDetails?.grossWeight
        //           ? plantDetails?.grossWeight
        //           : 0
        //       ) * 0.454
        //     ).toFixed(3);
        //     frozenWeightInKg = (
        //       Number(
        //         plantDetails?.frozenWeight
        //           ? plantDetails?.frozenWeight
        //           : 0
        //       ) * 0.454
        //     ).toFixed(3);
        //     netWeightInKgs += Number(r.quatity)*0.454
        //     netWeightInLbs += Number(r.quatity)

        //   } else {
        //     {
        //       conditionRes?.[0]?.quantityUom === true
        //         ? (finalNetWeight = (
        //             Number(r.quatity) / 0.454
        //           ).toFixed(3))
        //         : (finalNetWeight = Number(r.quatity).toFixed(3));
        //     }
        //     unitPrice = Number(r.revisedPrice).toFixed(2);
        //     grossWeightInKg = Number(
        //       plantDetails?.grossWeight
        //         ? plantDetails?.grossWeight
        //         : 0
        //     ).toFixed(3);
        //     frozenWeightInKg = Number(
        //       plantDetails?.frozenWeight
        //         ? plantDetails?.frozenWeight
        //         : 0
        //     ).toFixed(3);
        //     netWeightInKgs += Number(r.quatity)
        //     netWeightInLbs += Number(r.quatity)/0.454
         
        //   }
        // }
        // {conditionRes[0]?.isRevisedPrice === true? (
        //   // conditionRes?.[0]?.quantityUom === true?

        //   (uomPrice.name == UomEnum.LB || uomPrice.name == UomEnum.OZ?(
        //     invUnitPrice = (Number(r.revisedPrice ? r.revisedPrice : 0)*Number(2.20462)).toFixed(5)):
        //   (invUnitPrice = Number(r.revisedPrice ? r.revisedPrice : 0).toFixed(5)))
          
          
        // ): (
        //   (uomPrice.name == UomEnum.LB || uomPrice.name == UomEnum.OZ?(
        //     invUnitPrice = (Number(r.price ? r.price : 0)*Number(2.20462)).toFixed(5)):
        //   (invUnitPrice = Number(r.price ? r.price : 0).toFixed(5)))
        //   )}
        // totalLbWeight += Number(finalNetWeight);
        // totalAmount += Number(Number(invUnitPrice) * Number(finalNetWeight));
        
        // {
        //   conditionRes[0]?.isRevisedPrice === true
        //     ? ( conditionRes?.[0]?.quantityUom === true?
        //       invUnitPrice = Number(r.price ? r.price : 0).toFixed(2):
        //       invUnitPrice = (Number(r.price ? r.price : 0)*Number(2.20462)).toFixed(2)
        //     )
        //     : ( conditionRes?.[0]?.quantityUom === true?
        //       invUnitPrice = Number(r.revisedPrice ? r.revisedPrice : 0).toFixed(2):
        //       invUnitPrice = (Number(r.revisedPrice ? r.revisedPrice : 0)*Number(2.20462)).toFixed(2)
        //     );
        // }
        if (conditionRes?.[0]?.quantityUom === true) {
          // converting quantity to LB------
          if (uom.name == UomEnum.LB || uom.name == UomEnum.OZ) {
            finalNetWeight = Number(r.quatity)
          }else{
            finalNetWeight = Number(r.quatity)/ 0.454
          }
          // converting price to LB------
          if (
            uomPrice.name == UomEnum.LB ||
            uomPrice.name == UomEnum.OZ
          ) {
            unitPrice = Number(r.price).toFixed(5);
          } else {
            unitPrice = (Number(r.price) * 0.454).toFixed(5);
          }
        } else {
          // converting price to KG------
           if (uomPrice.name == UomEnum.LB || uomPrice.name == UomEnum.OZ) {
          unitPrice = (Number(r.price) / 0.454).toFixed(5);
          }else{
            unitPrice = (Number(r.price)).toFixed(5);
          }
          // converting quantity to KG------
          if (uom.name == UomEnum.LB || uom.name == UomEnum.OZ) {
            finalNetWeight = Number(r.quatity) * 0.454
          }else{
            finalNetWeight = Number(r.quatity)
          }
        }
console.log(plantDetails?.grossWeight,'ooooooooo');

        if (uom.name == UomEnum.LB || uom.name == UomEnum.OZ) {
          // grossweight converting to KG----------
          grossWeightInKg = (
            Number(
              plantDetails?.grossWeight
                ? plantDetails?.grossWeight
                : 0
            ) * 0.454
          ).toFixed(3);
          console.log(plantDetails?.grossWeight*0.454,'osssss');
          
          // frozenweight converting to KG----------

          frozenWeightInKg = (
            Number(
              plantDetails?.frozenWeight
                ? plantDetails?.frozenWeight
                : 0
            ) * 0.454
          ).toFixed(3);
          netWeightInKgs += Number(r.quatity) * 0.454;
          netWeightInLbs += Number(r.quatity);
        } else {
          // grossweight converting to LB----------
          grossWeightInKg = Number(
            plantDetails?.grossWeight
              ? plantDetails?.grossWeight
              : 0
          ).toFixed(3);
          // frozenweight converting to LB----------

          frozenWeightInKg = Number(
            plantDetails?.frozenWeight
              ? plantDetails?.frozenWeight
              : 0
          ).toFixed(3);
          netWeightInKgs += Number(r.quatity);
          netWeightInLbs += Number(r.quatity) / 0.454;
        }
      }
      // console.log(grossWeightInKg,'iiiiiiiiiiiiii');
      
        totalLbWeight += Number(finalNetWeight);
        totalInvoiceAmount += Number(
          Number(unitPrice) * Number(finalNetWeight)
        );
        // {
        //   conditionRes?.[0]?.cvd === true
        //     ? (subTotal = Number(
        //       totalInvoiceAmount -
        //           Number(
        //             plantDetails.freightCharges
        //               ? plantDetails.freightCharges
        //               : 0
        //           )
        //       ))
        //     : 0;
        // }
        // {
        //   conditionRes?.[0]?.cvd === true
        //     ? (cvdVal = (
        //         Number(subTotal) * Number(4.36 / 100)
        //       ).toFixed(2))
        //     : 0;
        // }
        // {
        //   conditionRes?.[0]?.cvd === true
        //     ? (antiDumping = (subTotal * (1.35 / 100)).toFixed(2))
        //     : conditionRes?.[0]?.freightRate === true
        //     ? (antiDumping = Number(
        //         Number(
        //           totalInvoiceAmount -
        //             Number(
        //               plantDetails.freightCharges
        //                 ? plantDetails.freightCharges
        //                 : 0
        //             )
        //         ) *
        //           (1.35 / 100)
        //       ).toFixed(2))
        //     : (antiDumping = (
        //         Number(totalInvoiceAmount) *
        //         (1.35 / 100)
        //       ).toFixed(2));
        // }
        // {
        //   conditionRes?.[0]?.cvd === true
        //     ? (fob =
        //         Number(subTotal ? subTotal : 0) -
        //         Number(antiDumping ? antiDumping : 0) -
        //         Number(cvdVal ? cvdVal : 0))
        //     : conditionRes?.[0]?.freightRate === true
        //     ? (fob = Number(
        //         totalInvoiceAmount -
        //           Number(
        //             plantDetails.freightCharges
        //               ? plantDetails.freightCharges
        //               : 0
        //           ) -
        //           Number(antiDumping)
        //       ).toFixed(2))
        //     : (fob = Number(
        //         totalInvoiceAmount - Number(antiDumping)
        //       ).toFixed(2));
        // }
        return (
          <tr key={index}>
            <td
              className="ta-b"
              rowSpan={totalContainersRowSpan}
              style={{
                display:
                  totalContainersRowSpan-- == copiedContainerRowSpan
                    ? ''
                    : 'none'
              }}
            >
              <b>Container No:</b>
              &nbsp;
              {/* {plantDetails?.saleOrderItems[0]?.containerNo} */}
              <br />
              <hr />
              <b>Seal No:</b>
              {/* {plantDetails?.saleOrderItems[0]?.linearSelaNo} */}
            </td>
            <td
              className="ta-b"
              rowSpan={containerProductLevelRowSpan.get(prodIndex)}
              colSpan={plantDetails?.isItem === true ? 2 : 3}
              style={{
                display: prodRowSpan-- == containerProductLevelRowSpan.get(prodIndex) ? '' : 'none',
                textAlign:"center",
                whiteSpace: 'pre-wrap'
              }}
            >
              {g.productDescription}
            </td>
            {plantDetails?.isItem === true ? (
              <td className="ta-b" style={{textAlign:"center"}}>{r.itemCode}</td>
            ) : (
              <></>
            )}
            <td className="ta-b" style={{textAlign:"center"}}>
              {r.minGrade}/{r.maxGrade}
              {r.grade && (
                <>
                  <br />({r.grade})
                </>
              )}
            </td>
{hasBundelCategory?(
            <td className="ta-b" style={{textAlign:"center"}}>{r.noOfBundels}</td>
          ):(
            <td className="ta-b" style={{textAlign:"center"}}>{r.noOfCases}</td>
          )}
            {/* <td className="ta-b" style={{textAlign:"center"}}>{r.noOfCases}</td> */}
            <td className="ta-b" style={{textAlign:"center"}}>
              {finalNetWeight
                ? Number(finalNetWeight).toLocaleString(undefined, {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })
                : 0}
            </td>
            <td className="ta-b" style={{textAlign:"center"}}>{unitPrice}</td>
            <td className="ta-b" style={{textAlign:"center"}}>
              {r.netAmount}
              {/* {Number(
                Number(invUnitPrice) * Number(finalNetWeight)
              )?.toLocaleString(undefined, {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })} */}
            </td>
          </tr>
        );
      });
    })
  }

  
  {/* <tr>
    <td className={'ta-b'}>
      <b>Net Weight</b>
    </td>

    
    {conditionRes?.[0]?.lbParam == true ? (
      <td className={'ta-b'}>
         {Number(netWeightInLbs)?.toFixed(2)}
        (LBS)
      </td>
    ) : (
      <td className={'ta-b'}></td>
    )}
    <td className={'ta-b'}>
      {Number(netWeightInKgs)?.toFixed(2)}
      (KGS)
    </td>
    {conditionRes?.[0]?.isHsn === true ? (
      <td
        className={'ta-b'}
        rowSpan={conditionRes?.[0]?.frozenWeight === true ? 3 : 2}
      >
        <b>HSN Code: </b>
        {plantDetails?.saleOrderItems?.map((item) => {
          return (
            <>
              <span>{item.foodTypeHsnCode}</span>
              <br />
            </>
          );
        })}
      </td>
    ) : (
      <td
        className={'ta-b'}
        rowSpan={conditionRes?.[0]?.frozenWeight === true ? 3 : 2}
      ></td>
    )}

    {conditionRes[0]?.blNo === true ? (
      <>
        <td className={'ta-b'}>
          <b>Total</b>
        </td>
        <td className={'ta-b'}>{totalCases}</td>
        <td className={'ta-b'}>
          {totalLbWeight
            ? Number(totalLbWeight)?.toLocaleString(undefined, {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })
            : 0}
        </td>
        <td className={'ta-b'}></td>
        <td className={'ta-b'}>
          {Number(totalAmount)?.toLocaleString(
            CrrencySymbols.find(
              (item) =>
                item.name ==
                plantDetails?.saleOrderItems[0]?.currencyDetails
            )?.locale,
            { minimumFractionDigits: 2, maximumFractionDigits: 2 }
          )}
        </td>
      </>
    ) : (
      <>
        <td className={'ta-b'}></td>
        <td className={'ta-b'}></td>
        <td className={'ta-b'}></td>
        <td className={'ta-b'}></td>
        <td className={'ta-b'}></td>
      </>
    )}
  </tr>
 
  {conditionRes?.[0]?.frozenWeight === true ? (
    <tr>
      <td className={'ta-b'}>
        <b>Frozen Weight</b>
      </td>
    
      {conditionRes?.[0]?.lbParam == true ? (
        <td className={'ta-b'}>
          {Math.round(
            frozenWeightInKg / 0.454
          )?.toLocaleString('en-US', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })}
          (LBS)
        </td>
      ) : (
        <td className={'ta-b'}></td>
      )}
        <td className={'ta-b'}>
        {Math.round(frozenWeightInKg)?.toLocaleString('en-US', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })}
        (KGS)
      </td>
      {conditionRes?.[0]?.blNo == true ? (
        <></>
      ) : (
        <>
          <td className={'ta-b'}></td>
          <td className={'ta-b'}></td>
          <td className={'ta-b'}></td>
          <td className={'ta-b'}></td>
        </>
      )}
    </tr>
  ) : (
    ''
  )}
  <tr>
    <td className={'ta-b'}>
      <b>Gross Weight</b>
    </td>

    {conditionRes?.[0]?.lbParam == true ? (
      <td className={'ta-b'}>
        {Math.round(
          grossWeightInKg / 0.454
        )?.toLocaleString('en-US', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })}
        (LBS)
      </td>
    ) : (
      <td className={'ta-b'}></td>
    )}
    
    <td className={'ta-b'}>
      {Math.round(grossWeightInKg)?.toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })}
      (KGS)
    </td>
    {conditionRes?.[0]?.blNo == true ? (
      <>
        <td
          className={'ta-b'}
          colSpan={5}
          rowSpan={conditionRes?.[0]?.frozenWeight === true ? 2 : 1}
        >
          <b>BILL OF LADING NO:</b>
          {plantDetails?.saleOrderItems[0]?.billOfLadingno}
        </td>
      </>
    ) : (
      <>
        <td className={'ta-b'}>
          <b>Total</b>
        </td>
        <td className={'ta-b'} style={{textAlign:"center"}}>{totalCases}</td>
        <td className={'ta-b'} style={{textAlign:"center"}}>
          {totalLbWeight
            ? Number(totalLbWeight)?.toLocaleString(undefined, {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })
            : 0}
        </td>
        <td className={'ta-b'}></td>
        <td className={'ta-b'} style={{textAlign:"center"}}>
        {Number(totalInvoiceAmount).toLocaleString(undefined, {
minimumFractionDigits: 2,
maximumFractionDigits: 2,
})}
          {/* {Number(totalAmount)?.toLocaleString(
            CrrencySymbols.find(
              (item) =>
                item.name ==
                plantDetails?.saleOrderItems[0]?.currencyDetails
            )?.locale,
            { minimumFractionDigits: 2, maximumFractionDigits: 2 }
          )} 
        </td>
      </>
    )}
  </tr> */}


      
{/* {
                plantDetails?.saleOrderItems?.map(item => {



                  netWeightInKgs += Number(item.netWeight) * 0.454;
                  let freightCharges = plantDetails?.freightCharges === undefined ? 0 : plantDetails?.freightCharges;
                  let exchangeRate = plantDetails?.exchangeRate === undefined ? 0 : plantDetails?.exchangeRate;

                  totalCases += item.invoicedCases
                    ;
                  const uom = UnitsOfWeightInput.find(uom => uom.value == item.uomId);
                  let finalNetWeight;
                  let unitPrice;
                  let invUnitPrice;


                  if (plantDetails.isInvoiced == GlobalStatus.YES) {
                    if (uom.name == UomEnum.LB || uom.name == UomEnum.OZ) {
                      finalNetWeight = (Number(item.invoicedQty) * 0.454).toFixed(3);
                      unitPrice = (Number(item.revisedUnitPrice) / 0.454).toFixed(5);

                    } else {
                      finalNetWeight = Number((item.invoicedQty)).toFixed(3);
                      unitPrice = Number(item.unitPrice).toFixed(5);

                    }
                    if (plantDetails.totalAmount > Number(itemsTotalAmount)) {

                      let totalAm = Number((Number(invUnitPrice) * Number(finalNetWeight)).toFixed(2))
                      let deciamlValue = (Number(totalAm.toLocaleString().slice(Number(totalAm.toLocaleString().length) - 2)))
                      if (plantDetails.saleOrderItems.length > 1) {

                        do {
                          unitPrice = Number(Number(unitPrice) + Number(0.00001)).toFixed(5)
                        }
                        while ((plantDetails.totalAmount) <= Number(itemsTotalAmount));


                      } else {
                        unitPrice = Number(Number(unitPrice) + Number(0.00001)).toFixed(5)
                      }
                    }


                  }
                  else {
                    if (uom.name == UomEnum.LB || uom.name == UomEnum.OZ) {
                      finalNetWeight = (Number(item.netWeight) * 0.454).toFixed(3);
                      unitPrice = (Number(item.unitPrice) / 0.454).toFixed(5);
                    } else {
                      finalNetWeight = Number(item.netWeight).toFixed(3);
                      unitPrice = Number(item.unitPrice).toFixed(5);
                    }
                  }

                  if (plantDetails?.country === 'INDIA') {
                    // if (uom.name == UomEnum.LB || uom.name == UomEnum.OZ) {
                    //   invUnitPrice = ((Number(item.revisedUnitPrice ? item.revisedUnitPrice : item.unitPrice)) * 0.454).toFixed(5)
                    // } else {
                      // invUnitPrice = (Number(item.revisedUnitPrice ? item.revisedUnitPrice : item.unitPrice))
                      invUnitPrice = item.unitPrice
                    // }
                  } else if (plantDetails?.country === 'USA') {
                    // if (uom.name == UomEnum.LB || uom.name == UomEnum.OZ) {
                      invUnitPrice = ((Number(item.revisedUnitPrice ? item.revisedUnitPrice : item.unitPrice)) / 0.454).toFixed(5)
                    } else {
                      invUnitPrice = (Number(item.revisedUnitPrice ? item.revisedUnitPrice : item.unitPrice))
                    }
                  

                  totalLbWeight += Number(finalNetWeight);
                  // totalAmount += Number((Number(unitPrice) * Number(finalNetWeight)).toFixed(2));
                  totalAmount = item.invoiceAmount;
                  
                  newUnitPrice = Number(totalAmount / finalNetWeight).toFixed(5)
                  newTotalAmount = Number(Number(finalNetWeight) * Number(newUnitPrice))
                  totalAmnt += (Number((invUnitPrice) * (finalNetWeight)));

                  let insurance = 0;
                  if (plantDetails?.isInvoiced == GlobalStatus.YES) {
                    if (plantDetails?.insurance) {
                      insurance += plantDetails?.insurance;
                    }
                  }
                  // FOBInRs = totalAmount - freightCharges - insurance;
                  // FOBInUSD = (totalAmount - freightCharges - insurance) * exchangeRate;

                  const fobVal = (totalAmnt - freightCharges).toFixed(2)
                  FOBInRs = (Number(fobVal)) * exchangeRate;
                  FOBInUSD = (totalAmnt - freightCharges); //changed totalAmount to totalAmnt for fobValue
                  totalGrossWeight += Number(item.grossWeight);
                  totalFrozenWeight += Number(item.frozenWeight);

                  lbPouchWeight = Number(item.pouchWeight)
                  kgPouchWeight = Number(item.pouchWeight)
                  if (uom.name == UomEnum.OZ) {
                    lbPouchWeight = lbPouchWeight * 0.0625
                  }
                  if (uom.name == UomEnum.Gms) {
                    kgPouchWeight = kgPouchWeight * 0.001
                  }
             
                  let latinName = item.itemName === "Vannamei" ? "LITOPENAEUS VANNAMEI" : item.itemName === "Black Tiger" || "Sea Tiger" ? "PENAEUS MONODON" : "";
                  // let shrimp = item.itemName.toUpperCase() === "VANNAME"?"SHRIMP":"";
                  let shrimp = "SHRIMPS";
                  let hasNumber = /\d/;
                  let normalOrder = hasNumber.test(plantDetails?.buyerPoNo);
                  let lotRefString = '';
                  let lotNo = '';
                  let RefNo = '';
                  if (normalOrder) {
                    if (plantDetails?.lotCode) {
                      lotNo = 'LOT NO. ' + plantDetails?.lotCode + ','
                    }
                    if (plantDetails?.buyerPoNo) {
                      RefNo = 'REF NO. ' + plantDetails?.buyerPoNo
                    }
                    lotRefString = lotNo + RefNo
                  }
                  // let foodType = item.foodTypeName?item.foodTypeName.toUpperCase():" ";
                  return (
                    <>
                    <tr>
                        <td className={'ta-b'}></td>
                        <td className={'ta-b'} colSpan={3}>
                            {((item.foodTypeCode?.toLocaleUpperCase('en-US').charAt(0) == "C") ? 'COOKED' : item.foodTypeName?.toLocaleUpperCase('en-US')) + ' FROZEN ' + ((item.valueAdditionOneIdCode === 'EZPeel') ? ' HEADLESS ' : '') + item.valueAdditionOneIdName?.toLocaleUpperCase('en-US') + ' ' + (
                              (!(([
                                'HLSO', 'HOSO', 'EZPeel', 'N/A'
                               ].indexOf(item.valueAdditionOneIdCode)) > -1) ? " AND " : '')
                            ) + (item.valueAdditionTwoIdCode ? item.valueAdditionTwoIdName?.toLocaleUpperCase('en-US') : '')}<br />{(item.valueAdditionThreeIdCode ? item.valueAdditionThreeIdName?.toLocaleUpperCase('en-US') : '') + ' ' + (item.valueAdditionFiveIdCode ? item.valueAdditionFiveIdName?.toLocaleUpperCase('en-US') : '') + ' ' + item.itemName?.toLocaleUpperCase('en-US') + ' ' + shrimp?.toUpperCase() + ',' + item.valueAdditionFourIdName?.toLocaleUpperCase('en-US')}<br />
                            {'LATIN NAME : ' + latinName.toUpperCase()}<br />
                            {' BRAND : ' + item.displayBrandName?.toUpperCase()}<br />
                            {lotRefString}<br />
                            {plantDetails?.finNumber ? ('FPO#/FIN# ' + (plantDetails?.finNumber)) : ''}
                          </td>
                        <td className={'ta-b'} >{item.minGrade + '/' + item.maxGrade}</td>
                        <td className={'ta-b'} >{item.invoicedCases}</td>
                        <td className={'ta-b'} >{(finalNetWeight) ? Number(finalNetWeight).toLocaleString(undefined, { minimumFractionDigits: 3, maximumFractionDigits: 3 }) : 0}</td>
                        <td className={'ta-b'} >{(invUnitPrice) ? Number(invUnitPrice).toLocaleString(undefined, { minimumFractionDigits: 3, maximumFractionDigits: 3 }) : 0}</td>
                        <td className={'ta-b'} >{Number(Number(invUnitPrice) * Number(finalNetWeight))?.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</td>
                    </tr>
                    </>
                    // <><tr style={{ border: '0px' }}>
                    //   <td style={{ textAlign: 'center' }}>{item.pouches + ' * ' + ((uom.name == UomEnum.LB || uom.name == UomEnum.OZ) ? lbPouchWeight.toFixed(2) : kgPouchWeight.toFixed(2)) + " " + ((uom.name == UomEnum.LB || uom.name == UomEnum.OZ) ? 'LB' : 'KG')}<br />
                    //     <span style={{ textAlign: 'center' }}>{Number(item.caseWeight).toFixed(2) + " " + ((uom.name == UomEnum.LB || uom.name == UomEnum.OZ) ? 'LB' : 'KG')}</span><br /><span style={{ textAlign: 'center' }}>{(uom.name == UomEnum.LB || uom.name == UomEnum.OZ) ? <>{(Number(item.caseWeight) * 0.454).toFixed(3) + ' KGS'}</> : <></>}</span></td>
                    //   <td style={{ textAlign: 'center' }}>{item.hsnCode}</td>
                    //   <td colSpan={2} style={{ textAlign: 'left', alignContent: 'center' }}>
                    //     {((item.foodTypeCode.toLocaleUpperCase('en-US').charAt(0) == "C") ? 'COOKED' : item.foodTypeName.toLocaleUpperCase('en-US')) + ' FROZEN ' + ((item.valueAdditionOneIdCode === 'EZPeel') ? ' HEADLESS ' : '') + item.valueAdditionOneIdName.toLocaleUpperCase('en-US') + ' ' + (
                    //       (!(([
                    //         'HLSO', 'HOSO', 'EZPeel', 'N/A'
                    //       ].indexOf(item.valueAdditionOneIdCode)) > -1) ? " AND " : '')
                    //     ) + (item.valueAdditionTwoIdCode ? item.valueAdditionTwoIdName.toLocaleUpperCase('en-US') : '')}<br />{(item.valueAdditionThreeIdCode ? item.valueAdditionThreeIdName.toLocaleUpperCase('en-US') : '') + ' ' + (item.valueAdditionFiveIdCode ? item.valueAdditionFiveIdName.toLocaleUpperCase('en-US') : '') + ' ' + item.itemName.toLocaleUpperCase('en-US') + ' ' + shrimp.toUpperCase() + ',' + item.valueAdditionFourIdName.toLocaleUpperCase('en-US')}<br />
                    //     {'LATIN NAME : ' + latinName.toLocaleUpperCase('en-US') + ' '}<br />
                    //     {' BRAND : ' + item.displayBrandName?.toLocaleUpperCase('en-US')}<br />
                    //     {lotRefString}<br />
                    //     {plantDetails?.finNumber ? ('FPO#/FIN# ' + (plantDetails?.finNumber)) : ''}
                    
                    //   </td>
                    //   <td style={{ textAlign: 'center' }} ></td>
                    //   <td className={'ta-b'} style={{ textAlign: 'center', borderTop: '0px', borderBottom: '0px' }}></td>
                    //   <td className={'ta-b'} style={{ textAlign: 'center', borderTop: '0px', borderBottom: '0px' }}></td>
                    //   <td className={'ta-b'} style={{ textAlign: 'center', borderTop: '0px', borderBottom: '0px' }}></td>
                    //   {/* <td className={'ta-b'} style={{textAlign:'center', borderTop:'0px', borderBottom:'0px'}}></td> 
                    // </tr><tr>
                    //     <td style={{ textAlign: 'center' }}></td>
                    //     <td style={{ textAlign: 'center' }}></td>
                    //     <td style={{ textAlign: 'left' }} colSpan={2}>{item.minGrade + '/' + item.maxGrade}</td>
                    //     <td style={{ textAlign: 'right' }}>{item.invoicedCases}</td>
                    //     <td className={'ta-b'} style={{ textAlign: 'right', borderTop: '0px', borderBottom: '0px' }}>{(finalNetWeight) ? Number(finalNetWeight).toLocaleString(undefined, { minimumFractionDigits: 3, maximumFractionDigits: 3 }) : 0}</td>
                    //     <td className={'ta-b'} style={{ textAlign: 'right', borderTop: '0px', borderBottom: '0px' }}> { Number(invUnitPrice) }</td> 
                    //     <td className={'ta-b'} style={{ textAlign: 'right', borderTop: '0px', borderBottom: '0px' }}>{Number((invUnitPrice) * (finalNetWeight))?.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</td>
                    //   </tr></>
                  )
                }
                )
              } */}
               <tr>
                <td className={'ta-b'}>
                  <b>Net Weight</b>
                </td>

                
                {conditionRes?.[0]?.lbParam == true ? (
                  <td className={'ta-b'}>
                      {Number(totalLbWeight).toLocaleString('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  })}
                    (LBS)
                  </td>
                ) : (
                  <td className={'ta-b'}></td>
                )}
                <td className={'ta-b'}>
                {Number(netWeightInKgs).toLocaleString('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  })}
                  (KGS)
                </td>
                {conditionRes?.[0]?.isHsn === true ? (
                  <td
                    className={'ta-b'}
                    rowSpan={conditionRes?.[0]?.frozenWeight === true ? 3 : 2}
                  >
                    <b>HSN Code: </b>
                    {[...new Set(plantDetails?.saleOrderItems?.map((item) => item.foodTypeHsnCode))].map((foodTypeHsnCode) => {
  return (
    <>
      <span>{foodTypeHsnCode}</span>
      <br />
    </>
  );
})}

                  </td>
                ) : (
                  <td
                    className={'ta-b'}
                    rowSpan={conditionRes?.[0]?.frozenWeight === true ? 3 : 2}
                  ></td>
                )}

                 {
                  <>
                    <td className={'ta-b'}></td>
                    <td className={'ta-b'}></td>
                    <td className={'ta-b'}></td>
                    <td className={'ta-b'}></td>
                    <td className={'ta-b'}></td>
                  </>
                } 
              </tr>
             
              {conditionRes?.[0]?.frozenWeight === true ? (
                <tr>
                  <td className={'ta-b'}>
                    <b>Frozen Weight</b>
                  </td>
                
                  {conditionRes?.[0]?.lbParam == true ? (
                    <td className={'ta-b'}>
                      {Math.round(
                        frozenWeightInKg / 0.454
                      )?.toLocaleString('en-US', {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })}
                      (LBS)
                    </td>
                  ) : (
                    <td className={'ta-b'}></td>
                  )}
                    <td className={'ta-b'}>
                    {Math.round(frozenWeightInKg)?.toLocaleString('en-US', {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}
                    (KGS)
                  </td>
                  {
                    <>
                      <td className={'ta-b'}></td>
                      <td className={'ta-b'}></td>
                      <td className={'ta-b'}></td>
                      <td className={'ta-b'}></td>
                    </>
                  }
                </tr>
              ) : (
                ''
              )}
              <tr>
                <td className={'ta-b'}>
                  <b>Gross Weight</b>
                </td>

                {conditionRes?.[0]?.lbParam == true ? (
                  <td className={'ta-b'}>
                    {Math.round(
                      grossWeightInKg / 0.454
                    )?.toLocaleString('en-US', {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}
                    (LBS)
                  </td>
                ) : (
                  <td className={'ta-b'}></td>
                )}
                
                <td className={'ta-b'}>
                  {Math.round(grossWeightInKg)?.toLocaleString('en-US', {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })}
                  (KGS)
                </td>
                {
                  <>
                    <td className={'ta-b'}>
                      <b>Total</b>
                    </td>
                    <td className={'ta-b'} style={{textAlign:"center"}}>{totalCases}</td>
                    <td className={'ta-b'} style={{textAlign:"center"}}>
                      {totalLbWeight
                        ? Number(totalLbWeight)?.toLocaleString(undefined, {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          })
                        : 0}
                    </td>
                    <td className={'ta-b'}></td>
                    <td className={'ta-b'} style={{textAlign:"center"}}>
                    {Number(totalInvoiceAmount).toLocaleString(undefined, {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })}
                      {/* {Number(totalAmount)?.toLocaleString(
                        CrrencySymbols.find(
                          (item) =>
                            item.name ==
                            plantDetails?.saleOrderItems[0]?.currencyDetails
                        )?.locale,
                        { minimumFractionDigits: 2, maximumFractionDigits: 2 }
                      )} */}
                    </td>
                  </>
                }
              </tr>
              {/* <tr>
                        <td className={'ta-b'}><b>Net Weight</b></td>
                        <td className={'ta-b'}>{(totalLbWeight) ? Number(totalLbWeight).toLocaleString(undefined, { minimumFractionDigits: 3, maximumFractionDigits: 3 }) : 0}(LBs)</td>
                        <td className={'ta-b'}>{(totalLbWeight) ? (Number((totalLbWeight * 0.454))).toLocaleString('en-US', { minimumFractionDigits: 3, maximumFractionDigits: 3 }): 0}(KGs)</td>
                        {conditionRes?.[0]?.isHsn === true ? (
                  <td
                    className={'ta-b'}
                    rowSpan={conditionRes?.[0]?.frozenWeight === true ? 3 : 2}
                  >
                    <b>HSN Code: </b>
                    {[...new Set(plantDetails?.saleOrderItems?.map((item) => item.foodTypeHsnCode))].map((foodTypeHsnCode) => {
  return (
    <>
      <span>{foodTypeHsnCode}</span>
      <br />
    </>
  );
})}
                    {/* {plantDetails?.saleOrderItems?.map((item) => {
                      return (
                        <>
                          <span>{item.foodTypeHsnCode}</span>
                          <br />
                        </>
                      );
                    })} 
                  </td>
                ) : (
                  <td
                    className={'ta-b'}
                    rowSpan={conditionRes?.[0]?.frozenWeight === true ? 3 : 2}
                  ></td>
                )}                        <td className={'ta-b'}></td>
                        <td className={'ta-b'}></td>
                        <td className={'ta-b'}></td>
                        <td className={'ta-b'}></td>
                        <td className={'ta-b'}></td>
                    </tr>
                    <tr>
                        <td className={'ta-b'}><b>Frozen Weight</b></td>
                        <td className={'ta-b'}>{(Math.round(plantDetails.frozenWeight ? plantDetails.frozenWeight : 0)).toLocaleString('en-US', { minimumFractionDigits: 3, maximumFractionDigits: 3 })}(LBs)</td>
                        <td className={'ta-b'}>{Math.round((plantDetails.frozenWeight * 0.454) ? (plantDetails.frozenWeight * 0.454) : 0).toLocaleString('en-US', { minimumFractionDigits: 3, maximumFractionDigits: 3 })}(KGs)</td>
                        <td className={'ta-b'}></td>
                        <td className={'ta-b'}></td>
                        <td className={'ta-b'}></td>
                        <td className={'ta-b'}></td>
    
                    </tr>
                    <tr>
                        <td className={'ta-b'}><b>Gross Weight</b></td>
                        <td className={'ta-b'}>{(Math.round(plantDetails.grossWeight ? plantDetails.grossWeight : 0)).toLocaleString('en-US', { minimumFractionDigits: 3, maximumFractionDigits: 3 })}(LBs)</td>
                        <td className={'ta-b'}>{Math.round((plantDetails.grossWeight * 0.454) ? (plantDetails.grossWeight * 0.454) : 0).toLocaleString('en-US', { minimumFractionDigits: 3, maximumFractionDigits: 3 })}(KGs)</td>
                        <td className={'ta-b'}><b>Total</b></td>
                        <td className={'ta-b'}>{totalCases}</td>
                        <td className={'ta-b'}>{(totalLbWeight) ? Number(totalLbWeight).toLocaleString(undefined, { minimumFractionDigits: 3, maximumFractionDigits: 3 }) : 0}</td>
                        <td className={'ta-b'}></td>
                        <td className={'ta-b'}> 
                      {Number(totalNetAmount).toLocaleString(CrrencySymbols.find(item => item.name == plantDetails?.saleOrderItems[0]?.currencyDetails)?.locale, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                      </td>
    
                    </tr> */}
                    <tr><td className={'ta-b'} colSpan={9} style={{ textAlign: 'center',}}><b>
                    (TOTAL U.S. Dollars&nbsp;&nbsp;:&nbsp;&nbsp;
                  {Number(totalInvoiceAmount) !== undefined 
                    ? (Number(totalInvoiceAmount) === 0 
                    ? "ZERO" 
                   : toWords?.convert(Number(totalInvoiceAmount), { currency: true })?.toUpperCase())
                   : ''}
                   )                      
                   </b></td></tr>
                   
                <tr>
                <td
                  className={'ta-b'}
                  colSpan={9}
                >
                  <b style={{ textAlign: 'left' }}>PACKED & PROCESSED BY : </b>
                  <h4 style={{ display: 'inline', textAlign: 'left' }}>
                    {processingData?.company ? processingData?.company : ''}
                  </h4>
          <br />
          {processingData?.addressOne ? processingData?.addressOne + ',' : ''}
          <br />
          {processingData?.addressTwo
            ? processingData?.addressTwo + ' - ' + processingData?.postalCode
            : ''}
          <br />
          {processingData?.state + ', ' + processingData?.country}
          <br />
          <b style={{ textAlign: 'center' }}>APPROVAL NUMBER :</b>
                  {exportersPlant?.approvalNum}{' '}
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  {exportersPlant?.feiNumber ? (
                    <>
                      <b style={{ textAlign: 'center' }}>USFDA REGN NO:</b>
                      {exportersPlant?.consigneefdaRegNumber}
                    </>
                  ) : (
                    <></>
                  )}
                </td>
                </tr>
                {/* <tr>
                  <td className={'ta-b'} colSpan={5} style={{ textAlign: 'right',}}>
                    <b>PREPAID FREIGHT :</b>
                  </td>
                  <td className={'ta-b'} colSpan={4} style={{ textAlign: 'left',}}>
                    <b>USD$ :</b>
                  </td>
                </tr> */}
                <tr>
                  <td className={'ta-b'} colSpan={5} style={{ textAlign: 'right',}}>
                    <b>PREPAID FREIGHT :</b>
                  </td>
                  <td className={'ta-b'} colSpan={4} style={{ textAlign: 'left',}}>
                    <b>USD$ : </b>
                  </td>
                </tr>
                {conditionRes?.[0]?.antiDumping===true&&(
                <tr>
                  <td className={'ta-b'} colSpan={5} style={{ textAlign: 'right',}}>
                    <b>ANTI DUMPING DUTY @1.35%:</b>
                  </td>
                  <td className={'ta-b'} colSpan={4} style={{ textAlign: 'left',}}>
                    <b>USD$ :</b>
                  </td>
                </tr>
                )}
                <tr>
                  <td className={'ta-b'} colSpan={5} style={{ textAlign: 'right',}}>
                    <b>FOB VALUE IN US$ :</b>
                  </td>
                  <td className={'ta-b'} colSpan={4} style={{ textAlign: 'left',}}>
                    <b>USD$ :</b>
                  </td>
                </tr>
                <tr>
                <td className={'ta-b'} colSpan={9} style={{ textAlign: 'left',}}>
                  <b>BANK DETAILS:</b><br/>
                  <b>NAME OF ACCOUNT&nbsp;:</b>{plantDetails?.bankInfo?.[0]?.displayName
                      ? plantDetails.bankInfo[0].displayName
                      : ''}<br/>
                  <b>BANK NAME&nbsp;:</b>{plantDetails?.bankInfo?.[0]?.bankName ? plantDetails.bankInfo[0].bankName:''}<br/>
                  <b>BRANCH&nbsp;&nbsp;&nbsp;&nbsp;:</b>{plantDetails?.bankInfo?.[0]?.branchName ? plantDetails.bankInfo[0].branchName:''}<br/>
                  <b>CURRENT ACCOUNT NO&nbsp;:</b>{plantDetails?.bankInfo?.[0]?.bankAcc ? plantDetails.bankInfo[0].bankAcc:''}<br/>
                  <b>SWIFT CODE&nbsp;&nbsp;:</b>{plantDetails?.bankInfo?.[0]?.swiftCode ? plantDetails.bankInfo[0].swiftCode:''}<br/>
                  <b>IFSC CODE&nbsp;&nbsp;&nbsp;:</b>{plantDetails?.bankInfo?.[0]?.ifscCode ? plantDetails.bankInfo[0].ifscCode:''}<br/>
                  <b>BANK ADDRESS&nbsp;:</b>{plantDetails?.bankInfo?.[0]?.bankAddress ? plantDetails.bankInfo[0].bankAddress:''}<br/>
                  </td>
                  </tr>
                  <tr>
                  <td colSpan={4} id='inputText' > <div style={{paddingLeft:"8px",verticalAlign:'top'}}><b>Declaration</b></div>
                  <div style={{paddingLeft:"8px"}}>
                  {conditionRes?.[0]?.declaration}
                  </div>
                 
                </td>
                <td colSpan={5} className={'ta-b'} style={{textAlign:'center'}}>
                  {/* <div className='stamp-and-print'> */}
                  <b>For </b>{' '}<b>{exporterData?.company}</b>

                  <br /><br /><br /><br />
                  <b><b>AUTHORISED SIGNATORY</b></b>
                  {/* </div> */}
                </td>
              </tr>
              {/* <tr >
                <td colSpan={3} rowSpan={2} className={'ta-b'}>
                  Consignee:<br />
                  {
                     plantDetails?.country === "INDIA" && (
                      <>
                         <b>AZ GEMS INDIA INC:</b>
                      </>
                     )
                  }
                  {
                    plantDetails?.country === "USA" && (
                      <><b>AZ GEMS INC:</b></>
                    )
                  }<br></br>
                  {plantDetails?.saleOrderItems[0]?.customeraddress?.split(",")[0] + ","}<br />
                  {plantDetails?.saleOrderItems[0]?.customeraddress?.split(",")[1] + ","}
                  {plantDetails?.saleOrderItems[0]?.customeraddress?.split(",")[2] + ","}
                  {plantDetails?.saleOrderItems[0]?.customeraddress?.split(",")[3]}<br />
                  {
                    plantDetails?.endCustomerName === 'AZ Gems' ?
                    <>
                    <b>FDA REGISTRATION NO.</b>{unitsData?.consigneefdaRegNumber}
                    </> : ''
                  }
                </td>
                <td colSpan={5} className={'ta-b'} >
                  <b>
                    Importer on record:
                  </b><br />
                  {
                     plantDetails?.country === "INDIA" && (
                      <>
                         <b>AZ GEMS INDIA INC:</b>
                      </>
                     )
                  }
                  {
                    plantDetails?.country === "USA" && (
                      <><b>AZ GEMS INC:</b></>
                    )
                  }<br />
                  {plantDetails?.saleOrderItems[0]?.customeraddress?.split(",")[0] + ","}<br />
                  {plantDetails?.saleOrderItems[0]?.customeraddress?.split(",")[1] + "," + plantDetails?.saleOrderItems[0]?.customeraddress?.split(",")[2] + "," + plantDetails?.saleOrderItems[0]?.customeraddress.split(",")[3]}
                  <br />{
                    plantDetails?.endCustomerName === 'AZ Gems' ?
                    <>
                    <b>FDA REGISTRATION NO.</b>{unitsData?.consigneefdaRegNumber}
                    </> : ''
                  }
                </td>
              </tr> */}
{/* 
              <tr>
                <td colSpan={3} className={'ta-b'}>
                  Country of Origin of Goods:<br />
                  <b > INDIA</b>
                </td>
                <td colSpan={5} className={'ta-b'}>
                  <b> Country of Final Destination:</b><br />
                  {plantDetails?.country}{' '}
                </td>
              </tr>
              <tr>
                <td className={'ta-b'} colSpan={2}>
                  Pre Carriage By:
                  <h4>Road</h4>
                </td>
                <td className={'ta-b'} colSpan={1}>
                  Place of Receipt of Pre-carrier:
                  <b>{plantDetails?.placeOfReceipt != undefined ? plantDetails.placeOfReceipt : null}</b>
                </td>
                <td colSpan={5} className={'ta-b'}>
                  Terms of Delivery and Payment:<br />
                  <span style={{ textAlign: 'center' }}><b>{plantDetails?.saleOrderItems[0]?.paymentTerms}</b></span>
                </td>
              </tr>

              <tr>

                <td className={'ta-b'} colSpan={2}>
                  Vessel / Flight No.

                  <b> {(plantDetails?.vesselName)?.toUpperCase()} </b>

                </td>
                <td className={'ta-b'} colSpan={1}>
                  Port of Loading: <br />

                  <b>{plantDetails?.portofloading ? (plantDetails?.portofloading)?.toUpperCase() + ', INDIA' : ''}</b>


                </td>

                <td colSpan={5} rowSpan={2} className={'ta-b'}>
                  Container No.&nbsp;
                  <b> {plantDetails?.saleOrderItems[0]?.containerNo} </b>
                  <br />
                  Liner Seal No.&nbsp;
                  <b>  {plantDetails?.saleOrderItems[0]?.linearSelaNo} </b>
                  <br />
                  Bill of Lading No.&nbsp;
                  <b> {plantDetails?.saleOrderItems[0]?.billOfLadingno}<br/><br/><br/> </b>
                </td>
              </tr>
              <tr>
                <td className={'ta-b'} colSpan={2}>
                  Port of Discharge:<br />
                  <b>{(plantDetails?.saleOrderItems[0]?.destinationDetails ? (plantDetails?.saleOrderItems[0]?.destinationDetails)?.toUpperCase() : '') + "," + (plantDetails?.country ? plantDetails?.country : '')}</b>
                </td>
                <td className={'ta-b'} colSpan={1}>
                  Final Destination:<br />
                  <b>{(plantDetails?.saleOrderItems[0]?.destinationDetails ? (plantDetails?.saleOrderItems[0]?.destinationDetails)?.toUpperCase() : '') + "," + (plantDetails?.country ? plantDetails?.country : '')}</b>
                </td>
              </tr>
              <tr>
                <td colSpan={1} style={{ textAlign: 'center', fontSize: 10 }}>
                  Marks & Nos / No & Kind of Pkgs
                </td>
                <td colSpan={1} style={{ textAlign: 'center' }}>
                </td>
                <td style={{ textAlign: 'center', paddingLeft: '55px' }} colSpan={2}>
                  Description of Goods
                </td>

                <td style={{ textAlign: 'center' }}>
                </td>
                <th className={'ta-b'} colSpan={1} style={{ textAlign: 'center', borderBottom: '0px' }} rowSpan={2}>
                  Quantity
                  <br />
                  {
                    plantDetails?.country === 'INDIA' ? <>
                      IN KGs
                    </> : <>IN LBs</>
                  } <br /> NET WEIGHT
                </th>
                <th className={'ta-b'} colSpan={1} style={{ textAlign: 'center', borderBottom: '0px' }} rowSpan={2}>
                  Rate
                  <br />
                  {
                    plantDetails?.country === 'INDIA' ? <>
                      PER KGs
                    </> : <>PER LBs</>
                  } <br />
                  <br />({plantDetails?.saleOrderItems[0]?.currencyDetails})
                  <br />{plantDetails?.shipmentTerms}
                  <br />{plantDetails?.saleOrderItems[0].destinationDetails}
                </th>
                <th className={'ta-b'} colSpan={1} style={{ textAlign: 'center', borderBottom: '0px' }} rowSpan={2}>
                  Amount
                  <br /> ({plantDetails?.saleOrderItems[0]?.currencyDetails})
                  <br /> {plantDetails?.shipmentTerms}
                  <br /> {plantDetails?.saleOrderItems[0].destinationDetails}
                </th>
              </tr>
              <tr>
                <th colSpan={1} style={{ textAlign: 'center' }}>
                </th>
                <th colSpan={1} style={{ textAlign: 'center' }}>
                  HSN Code
                </th>
                <th style={{ textAlign: 'left' }} colSpan={2}>
                  Size
                </th>
                <th style={{ textAlign: 'left', width: '30%' }}>
                  No. Of Cartons
                </th>
              </tr>

              {plantDetails?.saleOrderItems?.map(item => {
                const uom = UnitsOfWeightInput.find(uom => uom.value == item.uomId);
                let finaItemslNetWeight;
                let itemUnitPrice;
                if (plantDetails.isInvoiced == GlobalStatus.YES) {
                  if (uom.name == UomEnum.LB || uom.name == UomEnum.OZ) {
                    finaItemslNetWeight = (Number(item.invoicedQty) * 0.454).toFixed(3);
                    itemUnitPrice = (Number(item.revisedUnitPrice) / 0.454).toFixed(5);
                  } else {
                    finaItemslNetWeight = Number(item.invoicedQty).toFixed(3);
                    itemUnitPrice = Number(item.revisedUnitPrice).toFixed(5);
                  }
                }
                itemsTotalAmount += Number(itemUnitPrice) * Number(finaItemslNetWeight);

              })}

              {
                plantDetails?.saleOrderItems?.map(item => {
                  netWeightInKgs += Number(item.netWeight) * 0.454;
                  console.log('netWeightInKgs', netWeightInKgs)

                  let freightCharges = plantDetails?.freightCharges === undefined ? 0 : plantDetails?.freightCharges;
                  let exchangeRate = plantDetails?.exchangeRate === undefined ? 0 : plantDetails?.exchangeRate;
                  totalCases += item.invoicedCases;
                  const uom = UnitsOfWeightInput.find(uom => uom.value == item.uomId);
                  let finalNetWeight;
                  let unitPrice;
                  let invUnitPrice;
                  if (plantDetails.isInvoiced == GlobalStatus.YES) {
                    if (uom.name == UomEnum.LB || uom.name == UomEnum.OZ) {
                      if (plantDetails?.country === 'INDIA') {
                        finalNetWeight = (Number(item.invoicedQty) * 0.454).toFixed(3);
                        unitPrice = Number(item.revisedUnitPrice).toFixed(5);
                      } else {
                        finalNetWeight = (Number(item.invoicedQty)).toFixed(3);
                        unitPrice = Number(item.revisedUnitPrice).toFixed(5);
                      }
                    } else {
                      finalNetWeight = Number((item.invoicedQty)).toFixed(3);
                      unitPrice = (Number(item.unitPrice)).toFixed(5);
                    }
                  }

                  else {
                    if (uom.name == UomEnum.LB || uom.name == UomEnum.OZ) {
                      finalNetWeight = (Number(item.netWeight) / 0.454).toFixed(3);
                      unitPrice = (Number(item.revisedUnitPrice) * 0.454).toFixed(5);
                    } else {
                      finalNetWeight = Number(item.netWeight).toFixed(3);
                      unitPrice = Number(item.revisedUnitPrice).toFixed(5);
                    }
                  }

                  if (plantDetails?.country === 'INDIA') {
                    // if (uom.name == UomEnum.LB || uom.name == UomEnum.OZ) {
                    //   invUnitPrice = (Number(item.revisedUnitPrice ? item.revisedUnitPrice : item.unitPrice) * 0.454).toFixed(2)
                    // } else {
                      invUnitPrice = Number(item.revisedUnitPrice ? item.revisedUnitPrice : item.unitPrice).toFixed(5)
                    // }
                  } else if (plantDetails?.country === 'USA') {
                    // if (uom.name == UomEnum.KG) {
                    //   invUnitPrice = (Number(item.revisedUnitPrice ? item.revisedUnitPrice : item.unitPrice) / 0.454).toFixed(5)
                    // } else {
                      invUnitPrice = Number(item.revisedUnitPrice ? item.revisedUnitPrice : item.unitPrice).toFixed(5)
                    // }
                  }

                  console.log(invUnitPrice)
                  totalLbWeight += Number(finalNetWeight);
                  totalGrossWeight += (Number(item.grossWeightPerKg) * Number(item.invoicedCases));
                  // totalAmount += Number((Number(unitPrice) * Number(finalNetWeight)).toFixed(2)); Number(finalNetWeight * Number(item.revisedUnitPrice ? item.revisedUnitPrice : item.unitPrice))
                  totalAmount = item.invoiceAmount;
                  totalAm += Number(Number(invUnitPrice) * Number(finalNetWeight));
                  // totalAmount += (Number(plantDetails?.totalAmount))
                  FOBInRs = totalAmount - freightCharges;
                  FOBInUSD = (totalAmount - freightCharges) * exchangeRate;


                  let latinName = item.itemName === "Vannamei" ? "LITOPENAEUS VANNAMEI" : item.itemName === "Black Tiger" || "Sea Tiger" ? "PENAEUS MONODON" : "";
                  // let shrimp = item.itemName.toUpperCase() === "VANNAME"?"SHRIMPS":"";
                  let shrimp = "SHRIMPS";
                  let outputWeight = '';
                  if (uom.name == UomEnum.LB || uom.name == UomEnum.OZ) {
                    outputWeight = UomEnum.LB;
                  } else if (uom.name == UomEnum.KG || uom.name == UomEnum.Gms) {
                    outputWeight = UomEnum.KG;
                  }

                  lbPouchWeight = Number(item.pouchWeight)
                  kgPouchWeight = Number(item.pouchWeight)
                  if (uom.name == UomEnum.OZ) {
                    lbPouchWeight = lbPouchWeight * 0.0625
                  }
                  if (uom.name == UomEnum.Gms) {
                    kgPouchWeight = kgPouchWeight * 0.001
                  }


                  return (
                    <><tr style={{ border: '0px' }}>
                      <td style={{ textAlign: 'center' }}>{item.pouches + ' * ' + ((uom.name == UomEnum.LB || uom.name == UomEnum.OZ) ? lbPouchWeight.toFixed(2) : kgPouchWeight.toFixed(2)) + " " + ((uom.name == UomEnum.LB || uom.name == UomEnum.OZ) ? 'LB' : 'KG')}<br />
                        <span style={{ textAlign: 'center' }}>{Number(item.caseWeight).toFixed(2) + " " + ((uom.name == UomEnum.LB || uom.name == UomEnum.OZ) ? 'LB' : 'KG')}</span><br /><span style={{ textAlign: 'center' }}>{(uom.name == UomEnum.LB || uom.name == UomEnum.OZ) ? <>{(Number(item.caseWeight) * 0.454).toFixed(3) + ' KGS'}</> : <></>}</span></td>
                      <td style={{ textAlign: 'center' }}>{item.hsnCode}</td>
                      <td colSpan={2} style={{ textAlign: 'left' }}>
                        {((item.foodTypeCode.toLocaleUpperCase('en-US').charAt(0) == "C") ? 'COOKED' : item.foodTypeName.toLocaleUpperCase('en-US')) + ' FROZEN ' + ((item.valueAdditionOneIdCode === 'EZPeel') ? ' HEADLESS ' : '') + item.valueAdditionOneIdName.toLocaleUpperCase('en-US') + ' ' + (
                          (!(([
                            'HLSO', 'HOSO', 'EZPeel', 'N/A'
                          ].indexOf(item.valueAdditionOneIdCode)) > -1) ? " AND " : '')
                        ) + (item.valueAdditionTwoIdCode ? item.valueAdditionTwoIdName.toLocaleUpperCase('en-US') : '')}<br />{(item.valueAdditionThreeIdCode ? item.valueAdditionThreeIdName.toLocaleUpperCase('en-US') : '') + ' ' + (item.valueAdditionFiveIdCode ? item.valueAdditionFiveIdName.toLocaleUpperCase('en-US') : '') + ' ' + item.itemName.toLocaleUpperCase('en-US') + ' ' + shrimp.toUpperCase() + ',' + item.valueAdditionFourIdName.toLocaleUpperCase('en-US')}<br />
                        {'LATIN NAME : ' + latinName.toUpperCase()}<br />
                        {' BRAND : ' + item.displayBrandName?.toUpperCase()}<br />
                        {lotRefString}<br />
                        {plantDetails?.finNumber ? ('FPO#/FIN# ' + (plantDetails?.finNumber)) : ''}
                      </td>
                      <td style={{ textAlign: 'center' }} ></td>
                      <td className={'ta-b'} style={{ textAlign: 'center', borderTop: '0px', borderBottom: '0px' }}></td>
                      <td className={'ta-b'} style={{ textAlign: 'center', borderTop: '0px', borderBottom: '0px' }}></td>
                      <td className={'ta-b'} style={{ textAlign: 'center', borderTop: '0px', borderBottom: '0px' }}></td>
                      <td className={'ta-b'} style={{textAlign:'center', borderTop:'0px', borderBottom:'0px'}}></td> 
                    </tr><tr>
                        <td style={{ textAlign: 'center' }}></td>
                        <td style={{ textAlign: 'center' }}></td>
                        <td style={{ textAlign: 'left' }} colSpan={2}>{item.minGrade + '/' + item.maxGrade}</td>
                        <td style={{ textAlign: 'right' }}>{item.invoicedCases}</td>
                        {console.log('------333------', finalNetWeight)}
                        <td className={'ta-b'} style={{ textAlign: 'right', borderTop: '0px', borderBottom: '0px' }}>{(finalNetWeight) ? Number(finalNetWeight).toLocaleString(undefined, { minimumFractionDigits: 3, maximumFractionDigits: 3 }) : 0}</td>
                        <td className={'ta-b'} style={{ textAlign: 'right', borderTop: '0px', borderBottom: '0px' }}>{(invUnitPrice)}</td>
                        <td className={'ta-b'} style={{ textAlign: 'right', borderTop: '0px', borderBottom: '0px' }}>{Number(Number(invUnitPrice) * Number(finalNetWeight))?.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</td>
                      </tr></>
                  )
                }
                )
              }

              <tr>
                <td className={'ta-b'} colSpan={4} style={{ textAlign: 'center' }}>
                  Total
                </td>
                <td colSpan={1} className={'ta-b'} style={{ textAlign: 'right' }}><b>
                  {totalCases}</b>
                </td>
                <td style={{ textAlign: 'right' }} className={'ta-b'}><b>
                  {(totalLbWeight) ? Number(totalLbWeight).toLocaleString(undefined, { minimumFractionDigits: 3, maximumFractionDigits: 3 }) : 0}</b>
                </td>
                <td className={'ta-b'} style={{ borderTop: '0px' }}></td>
                <td className={'ta-b'} style={{ borderTop: '0px' }}></td>
              </tr>

              <tr>
                <td colSpan={5} >
                  Amount chargeable <br /> (in words):  <b> U.S {(totalAm) ? (toWords.convert(totalAm, { currency: true }).toUpperCase()) : ""}</b>
                </td>
                <td colSpan={2} style={{ textAlign: 'left', borderBottom: '0px' }}>
                  <b>Total USD</b>
                </td>
                <td style={{ textAlign: 'right' }} className={'ta-b'}><b>
                  {Number(totalAm).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} 
                  {Number(totalAm).toLocaleString(CrrencySymbols.find(item => item.name == plantDetails?.saleOrderItems[0]?.currencyDetails).locale, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                </b></td>
              </tr>
              <br></br>
              <br></br>
              <br></br>
              <br></br>


              <tr>
                <td style={{ width: '20%' }} className={'ta-b'}></td>
                {
                  plantDetails.country === 'INDIA' ? <>
                    <td style={{ textAlign: 'center', width: '20%', borderBottom: '0px' }} className={'ta-b'}>
                      <h4><b>IN LBS</b></h4>
                    </td>
                    <td style={{ textAlign: 'center', width: '20%', borderBottom: '0px' }} className={'ta-b'}>
                      <h4><b>IN KGS</b></h4>
                    </td>
                  </> : <>
                    <td style={{ textAlign: 'center', width: '20%', borderBottom: '0px' }} className={'ta-b'}>
                      <h4><b>IN LBS</b></h4>
                    </td>
                    <td style={{ textAlign: 'center', width: '20%', borderBottom: '0px' }} className={'ta-b'}>
                      <h4><b>IN KGS</b></h4>
                    </td>
                  </>
                }

                <td style={{ width: '30%' }}></td>
                <td className={'ta-b'} colSpan={4} style={{ width: '10%', borderTop: '0px', borderLeft: '0px', borderBottom: '0px' }}></td>
              </tr>
              <tr>
                <td style={{ width: '20%', borderBottom: '0px' }} className={'ta-b'}>
                  {' '}
                  <b>TOTAL NET WT:{' '}</b>
                </td>
                {
                  plantDetails.country === 'INDIA' ? <>
                    <td style={{ textAlign: 'right', width: '20%', borderTop: '0px', borderBottom: '0px' }} className={'ta-b'}>
                      <h4>{(Number((totalLbWeight / 0.454))).toLocaleString('en-US', { minimumFractionDigits: 3, maximumFractionDigits: 3 })}</h4>
                    </td>
                    {console.log(Number(totalLbWeight / 0.454).toFixed(3))}
                    <td style={{ textAlign: 'right', width: '20%', borderTop: '0px', borderBottom: '0px' }} className={'ta-b'}>
                      <h4>{(totalLbWeight)?Number(Number(totalLbWeight).toFixed(3)):0}</h4> 
                      <h4>{(totalLbWeight).toLocaleString('en-US', { minimumFractionDigits: 3, maximumFractionDigits: 3 })}</h4>
                    </td>

                  </> :
                    <>
                      <td style={{ textAlign: 'right', width: '20%', borderTop: '0px', borderBottom: '0px' }} className={'ta-b'}>
                        <h4>{(totalLbWeight)?Number(Number(totalLbWeight).toFixed(3)):0}</h4> 
                        <h4>{(totalLbWeight).toLocaleString('en-US', { minimumFractionDigits: 3, maximumFractionDigits: 3 })}</h4>
                      </td>
                      <td style={{ textAlign: 'right', width: '20%', borderTop: '0px', borderBottom: '0px' }} className={'ta-b'}>
                        <h4>{(Number((totalLbWeight * 0.454))).toLocaleString('en-US', { minimumFractionDigits: 3, maximumFractionDigits: 3 })}</h4>
                      </td>
                    </>

                }

                <td colSpan={3} style={{ width: '30%', textAlign: 'center' }}>
                  TOTAL NO. OF MASTER CARTONS:
                </td>
                <td className={'ta-b'} colSpan={2} style={{ textAlign: 'right', width: '10%', borderTop: '0px', borderLeft: '0px', borderBottom: '0px' }}>
                  <h4><b>{totalCases}</b></h4>
                </td>


              </tr>
              <tr>
                <td style={{ width: '20%', borderTop: '0px' }} className={'ta-b'}>
                  {' '}
                  <b> TOTAL GROSS WT:</b>
                </td>
                <td style={{ textAlign: 'right', width: "20%", borderTop: '0px' }} className={'ta-b'}>
                  <h4>{(totalLbWeight)?Number(Number(totalLbWeight).toFixed(3)):0}</h4> 
                  <h4>{Math.round((totalGrossWeight / 0.454) ? (totalGrossWeight / 0.454) : 0).toLocaleString('en-US', { minimumFractionDigits: 3, maximumFractionDigits: 3 })}</h4>
                </td>
                <td style={{ textAlign: 'right', width: '20%', borderTop: '0px' }} className={'ta-b'}>
                  <h4>{(Math.round(totalGrossWeight ? totalGrossWeight : 0)).toLocaleString('en-US', { minimumFractionDigits: 3, maximumFractionDigits: 3 })}</h4>
                </td>
                <td colSpan={3} style={{ width: '30%', textAlign: 'center' }}>
                  TOTAL AMOUNT (IN {plantDetails?.saleOrderItems[0]?.currencyDetails}):
                </td>
                <td className={'ta-b'} colSpan={2} style={{ textAlign: 'right', width: '10%', borderTop: '0px', borderLeft: '0px', borderBottom: '0px' }}  >
                  <h4>
                    <b>{Number(totalAm).toLocaleString(CrrencySymbols.find(item => item.name == plantDetails?.saleOrderItems[0]?.currencyDetails).locale, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</b>
                    {Number(totalAmount).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} 
                  </h4>
                </td>
              </tr> 
              </table>
            <table style={{width:'100%',tableLayout:'fixed'}}> 

              <tr>
                <td colSpan={4} id='inputText'><b>Declaration :</b>
                  <TextArea style={{ outline: 'none', border: 'none' }} rows={3} contentEditable={true} defaultValue={defaultDeclaration}
                    onChange={(evt) => handleRemarks(evt)}
                  ></TextArea>
                </td>
                <td colSpan={4} className={'ta-b'}>
                  <div className='stamp-and-print'> 
                  <b>Signature and Date For :</b> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{' '}
                   <h4>SANDHYA AQUA EXPORTS PVT. LTD</h4> 
                  <h4>{plantDetails.invoicedPlant.company}</h4>

                  <br />
                  <h4>AUTHORISED SIGNATORY</h4>
                   </div> 
                </td>
              </tr> */}
            </table>

          </body>
        </html>
        : <Card title={<span style={{ color: 'black', borderColor: 'black', borderStyle: 'initial', height: '100' }}>Proforma Invoice</span>}
          style={{ textAlign: 'center' }} headStyle={{ backgroundColor: '#69c0ff' }}><span style={{ paddingTop: '10px', textAlign: 'center' }} ><Spin /></span></Card>}

    </div>
     </Card>
  )
}

export default ProformaInvoice;